{
  "actividades": {
    "title": "Activités",
    "subtitle": "Catalogue des activités avec coût horaire.",
    "fieldName": "Nom",
    "fieldNamePlaceholder": "Ex. Semis, Irrigation, Récolte",
    "fieldHourlyRateLabel": "Coût horaire",
    "fieldCurrency": "Devise",
    "fieldDescription": "Description (facultative)",
    "fieldDescriptionPlaceholder": "Description courte de l’activité...",
    "buttonCreate": "Créer une activité",
    "buttonSave": "Enregistrer les modifications",
    "actionEdit": "Modifier",
    "actionActivate": "Activer",
    "actionDeactivate": "Désactiver",
    "actionDelete": "Supprimer",
    "statusActive": "Active",
    "statusInactive": "Inactive",
    "perHour": "par heure",
    "currencies": {
      "USD": "Dollar américain",
      "CAD": "Dollar canadien",
      "BRL": "Réal brésilien"
    },
    "fieldDescriptionOptional": "Description (facultative)",
    "fieldNameLabel": "Nom",
    "fieldCurrencyLabel": "Devise",
    "fieldDescriptionLabel": "Description (facultative)",
    "errorRateInvalid": "Saisissez un coût horaire valide.",
    "errorRatePositive": "Le coût horaire doit être supérieur à 0."
  },
  "admins": {
    "actions": {
      "makeAdmin": "Convertir en admin",
      "makeOwner": "Convertir en propietario",
      "remove": "Eliminar acceso"
    },
    "banner": {
      "invitationSent": "Invitación enviada correctamente.",
      "removed": "Administrador eliminado de la organización.",
      "roleUpdated": "Rol actualizado."
    },
    "error": {
      "invite": "No se pudo enviar la invitación.",
      "load": "Error al cargar la lista de administradores.",
      "remove": "No se pudo eliminar al administrador.",
      "updateRole": "No se pudo actualizar el rol."
    },
    "form": {
      "buttonInvite": "Enviar invitación",
      "emailLabel": "Correo electrónico",
      "inviteTitle": "Invitar nuevo administrador",
      "roleLabel": "Rol"
    },
    "subtitle": "Gestiona los administradores de tu organización y sus roles.",
    "table": {
      "actions": "Acciones",
      "email": "Correo electrónico",
      "name": "Nombre",
      "noResults": "No hay administradores registrados.",
      "role": "Rol",
      "status": "Estado"
    },
    "title": "Administradores"
  },
  "app": {
    "brand": "GeoField GPS",
    "header": {
      "goToPanel": "Accéder au tableau de bord",
      "loggedAs": "Connecté en tant que",
      "login": "Se connecter",
      "loginMagic": "Lien magique",
      "logout": "Se déconnecter",
      "organizationAriaLabel": "Sélectionner une organisation",
      "organizationLabel": "Organisation",
      "organizationNone": "Aucune organisation",
      "roleAdmin": "Administrateur",
      "roleOwner": "Propriétaire",
      "roleTracker": "Tracker"
    },
    "tabs": {
      "actividades": "Activités",
      "admins": "Administrateur",
      "asignaciones": "Affectations",
      "planificacion": "Planification",
      "dashboard": "Panel de costos",
      "dashboardCostos": "Panel de costos",
      "panelCostos": "Panneau des coûts",
      "geocerca": "Géofence",
      "geocercas": "Geocercas",
      "home": "Inicio",
      "inicio": "Accueil",
      "invitar_tracker": "Invitar tracker",
      "invitarTracker": "Inviter un tracker",
      "nuevaGeocerca": "Geocerca",
      "panelTitle": "Panneau opérationnel",
      "goDashboard": "Aller au tableau",
      "pricing": "Tarifs",
      "reportes": "Rapports",
      "billing": "Facturation",
      "tracker": "Tracker",
      "resources": "Ressources",
      "benchmarking": "Benchmarking",
      "incidents": "Incidents"
    },
    "title": "GeoField GPS"
  },
  "onboardingCreateOrg": {
    "title": "Créez votre organisation",
    "body": "Créez l’espace de travail de votre entreprise pour commencer à superviser votre équipe terrain.",
    "nameLabel": "Nom de l’organisation",
    "namePlaceholder": "Exemple : Mon Entreprise",
    "submit": "Créer mon organisation",
    "creating": "Création…",
    "alreadyActive": "Vous avez déjà une organisation active.",
    "loginRequired": "Vous devez vous connecter.",
    "nameRequired": "Saisissez le nom de votre organisation.",
    "createdRedirecting": "Organisation créée. Redirection…",
    "limitReached": "Vous avez déjà créé une organisation. Vous pouvez changer d’organisation ou contacter le support pour en créer une autre.",
    "createFailed": "Impossible de créer l’organisation."
  },
  "asignaciones": {
    "actions": {
      "activate": "Activar",
      "deactivate": "Desactivar",
      "delete": "Eliminar",
      "edit": "Editar",
      "save": "Enregistrer l'affectation",
      "update": "Mettre à jour l'affectation",
      "cancel": "Annuler"
    },
    "banner": {
      "created": "Affectation créée avec succès.",
      "deleted": "Affectation supprimée.",
      "updated": "Affectation mise à jour."
    },
    "error": {
      "delete": "Impossible de supprimer l'affectation.",
      "endBeforeStart": "La date/heure de fin ne peut pas être antérieure à la date/heure de début.",
      "invalidFrequency": "La fréquence doit être d’au moins 5 minutes.",
      "invalidPerson": "Vous devez sélectionner une personne valide.",
      "load": "Erreur lors du chargement des affectations.",
      "missingActivity": "Vous devez sélectionner une activité.",
      "missingEnd": "Vous devez saisir la date/heure de fin.",
      "missingGeofence": "Vous devez sélectionner une zone.",
      "missingPerson": "Vous devez sélectionner une personne.",
      "missingStart": "Vous devez saisir la date/heure de début.",
      "noActiveOrg": "Il n'y a pas d'organisation active.",
      "personMissingUserId": "La personne sélectionnée n'a pas de user_id. Impossible de la lier comme tracker.",
      "save": "Impossible d'enregistrer l'affectation.",
      "update": "Erreur lors de la mise à jour de l'affectation."
    },
    "filters": {
      "refresh": "Refrescar",
      "refreshLoading": "Actualizando…",
      "status": {
        "activo": "Activos",
        "inactivo": "Inactivos",
        "todos": "Todos"
      },
      "statusLabel": "Estado",
      "searchPlaceholder": "Buscar (persona/geocerca)",
      "statusDefault": "Estado: todos",
      "statusAll": "Estado: todos",
      "geofenceAll": "Geocerca: todas",
      "personalAll": "Personal: todos"
    },
    "fields": {
      "person": "Personne",
      "geofence": "Géofence",
      "activity": "Activité",
      "startAt": "Date/heure de début",
      "endAt": "Date/heure de fin",
      "status": "Statut",
      "frequencyMinutes": "Fréquence (minutes)"
    },
    "statusOptions": {
      "active": "Actif"
    },
    "form": {
      "activityLabel": "Actividad",
      "activityPlaceholder": "Selecciona una actividad",
      "select": "Sélectionner",
      "buttonCancel": "Cancelar",
      "buttonCreate": "Crear asignación",
      "buttonUpdate": "Actualizar asignación",
      "cancelEditButton": "Cancelar edición",
      "editTitle": "Editar asignación",
      "endLabel": "Fecha/hora fin",
      "endOptionalHint": "Opcional",
      "frequencyLabel": "Frecuencia (minutos)",
      "geofenceLabel": "Geocerca",
      "geofencePlaceholder": "Selecciona una geocerca",
      "newTitle": "Nouvelle affectation",
      "personLabel": "Persona",
      "personPlaceholder": "Selecciona una persona",
      "quickActivity": {
        "newButton": "Nueva actividad",
        "newNamePlaceholder": "Nombre de la nueva actividad",
        "noActivitiesHint": "No hay actividades (cree una en el módulo Actividades o aquí abajo).",
        "saveButton": "Guardar actividad",
        "saving": "Guardando…"
      },
      "saveButton": "Guardar asignación",
      "startLabel": "Fecha/hora inicio",
      "statusActive": "Activa",
      "statusInactive": "Inactiva",
      "statusLabel": "Estado",
      "updateButton": "Actualizar asignación",
      "newActivityPlaceholder": "Nombre de la nueva actividad",
      "saveActivityButton": "Guardar actividad",
      "savingActivity": "Guardando…",
      "cancelButton": "Cancelar",
      "startDateLabel": "Fecha inicio",
      "startDatePlaceholder": "DD/MM/AAAA HH:MM o 2025-11-13T09:11",
      "endDateLabel": "Fecha fin (opcional)",
      "endDatePlaceholder": "DD/MM/AAAA HH:MM o 2025-11-14T19:17",
      "activityOptional": "(Opcional) Seleccione…",
      "createButtonLabel": "Crear asignación"
    },
    "messages": {
      "catalogError": "Error al cargar catálogos (personal, geocercas, actividades).",
      "confirmDelete": "¿Seguro que deseas eliminar esta asignación?",
      "createGenericError": "No se pudo crear la asignación.",
      "createSuccess": "Affectation créée avec succès.",
      "deleteError": "No se pudo eliminar la asignación.",
      "deleteSuccess": "Affectation supprimée avec succès.",
      "activatedSuccess": "Affectation activée avec succès.",
      "deactivatedSuccess": "Affectation désactivée avec succès.",
      "toggleStatusError": "Erreur lors du changement de statut.",
      "frequencyInvalidRange": "La frecuencia debe estar entre 5 minutos y 12 horas.",
      "frequencyTooLow": "La frecuencia mínima permitida es de 5 minutos.",
      "loadError": "Error al cargar las asignaciones.",
      "loadingData": "Cargando datos de asignaciones…",
      "noActivities": "No hay actividades creadas. Crea al menos una Actividad para poder asignar.",
      "noPersonal": "No hay personal vigente en esta organización. Reactiva o crea al menos una persona.",
      "overlapError": "La persona ya tiene una asignación activa que se solapa en ese rango de fechas.",
      "saveGenericError": "Ocurrió un error al guardar la asignación.",
      "selectDates": "Debes ingresar fecha y hora de inicio y de fin.",
      "selectPersonAndFence": "Debes seleccionar una persona y una geocerca.",
      "updateGenericError": "No se pudo actualizar la asignación.",
      "updateSuccess": "Asignación actualizada correctamente."
    },
    "table": {
      "actions": "Acciones",
      "activity": "Actividad",
      "end": "Fin",
      "frequency": "Freq (min)",
      "geofence": "Geocerca",
      "noResults": "No hay asignaciones registradas.",
      "person": "Persona",
      "start": "Inicio",
      "status": "Estado",
      "title": "Listado de asignaciones"
    },
    "title": "Asignaciones",
    "states": {
      "all": "todos",
      "active": "activa",
      "inactive": "inactiva"
    }
  },
  "auth": {
    "backToLogin": "Retour à la connexion",
    "errorTitle": "Échec de l'authentification",
    "invalidOrExpiredLink": "Le lien est invalide, a expiré ou a déjà été utilisé.",
    "processing": "Authentification en cours...",
    "timeout": "L'authentification a pris trop de temps. Réessayez.",
    "selection": {
      "title": "Sélectionner une organisation",
      "loading": "Chargement des organisations associées à votre utilisateur...",
      "invalidSessionTitle": "Session invalide",
      "invalidSessionBody": "Il n'y a pas de session active. Reconnectez-vous.",
      "noOrganizationsBody": "Vous vous êtes connecté avec succès, mais nous n'avons trouvé aucune organisation associée à votre utilisateur.",
      "noOrganizationsHelp": "Contactez l'administrateur pour qu'il vous attribue une organisation, ou créez-en une nouvelle depuis le panneau d'administration.",
      "subtitle": "Vous vous êtes connecté avec succès. Choisissez maintenant l'organisation avec laquelle vous souhaitez travailler.",
      "noName": "(sans nom)",
      "code": "Code : {{code}}",
      "noCode": "Aucun code défini"
    },
    "requireOrg": {
      "loading": "Chargement de votre session et de l'organisation actuelle...",
      "resolvingOrganization": "Résolution de votre organisation..."
    },
    "callback": {
      "title": "Auth Callback",
      "invalidLinkTitle": "Le lien d'accès n'est plus valide",
      "invalidLinkDetail": "Cela se produit si le lien a expiré, ou s'il a été ouvert ou scanné auparavant, par exemple par un aperçu d'email ou s'il a été ouvert deux fois.",
      "invalidLinkTipLatest": "Utilisez l'email le plus récent et ouvrez-le une seule fois.",
      "invalidLinkTipBrowser": "Évitez de l'ouvrir dans le navigateur intégré de l'email. Si possible, utilisez Ouvrir dans Chrome.",
      "invalidLinkTipOwner": "Si cela échoue encore, demandez au propriétaire de renvoyer l'invitation.",
      "loginFailedTitle": "Impossible de terminer la connexion",
      "loginFailedDetail": "La session n'a pas pu être établie depuis le callback. Cela arrive généralement si le lien a déjà été consommé, a expiré, ou a été traité avec un client incorrect.",
      "loginFailedTipRetry": "Réessayez avec un nouveau lien.",
      "loginFailedTipDevice": "Ouvrez le lien sur le même appareil où vous l'avez reçu.",
      "confirmingSession": "Confirmation de la session...",
      "exchangingCode": "Échange du code...",
      "restoringSession": "Restauration de la session...",
      "noSessionFromCallback": "Impossible d'établir la session depuis le callback.",
      "creatingSecureCookies": "Création de cookies sécurisés...",
      "redirecting": "Redirection..."
    },
    "signup": {
      "title": "Créez votre compte gratuit",
      "subtitle": "Commencez à superviser votre équipe terrain avec GeoField GPS.",
      "labels": {
        "fullName": "Nom complet (facultatif)",
        "email": "E-mail"
      },
      "placeholders": {
        "fullName": "Votre nom",
        "email": "votre@email.com"
      },
      "buttons": {
        "creating": "Envoi...",
        "create": "Créer un compte gratuit"
      },
      "errors": {
        "invalidEmail": "Saisissez une adresse e-mail valide.",
        "mustAcceptTerms": "Vous devez accepter les Conditions et la Politique de confidentialité.",
        "sendFailed": "Impossible d'envoyer le Magic Link : {{message}}",
        "unknown": "Erreur inconnue{{#if message}} : {{message}}{{/if}}",
        "googleFailed": "Impossible de se connecter avec Google : {{message}}",
        "googleNoUrl": "Aucune URL de redirection reçue de Google.",
        "googleUnknown": "Erreur Google OAuth inconnue{{#if message}} : {{message}}{{/if}}"
      },
      "messages": {
        "magicLinkSent": "Nous vous avons envoyé un lien sécurisé. Vérifiez votre e-mail et ouvrez-le pour confirmer votre compte."
      },
      "terms": {
        "acceptance": "J’accepte les",
        "terms": "Conditions",
        "and": "et la",
        "privacy": "Politique de confidentialité"
      },
      "alreadyHaveAccount": "Vous avez déjà un compte ?",
      "loginLink": "Se connecter",
      "separator": "ou",
      "oauthGoogle": "S’inscrire avec Google"
    }
  },
  "authInvite": {
    "continue": "Continuar",
    "expiredOrUsed": "La invitación es inválida, ya expiró o fue utilizada.",
    "goToLogin": "Ir a iniciar sesión",
    "notInviteLink": "Este enlace no es una invitación válida. Usa el enlace de invitación que recibiste por correo.",
    "processing": "Validando invitación…",
    "timeout": "La validación de la invitación tardó demasiado. Intenta nuevamente.",
    "title": "Has sido invitado"
  },
  "accountPage": {
    "title": "Compte",
    "loading": "Chargement du compte...",
    "noActiveSession": "Il n'y a pas de session active",
    "sessionStatus": "État de la session",
    "user": "Utilisateur",
    "currentOrganization": "Organisation actuelle",
    "role": "Rôle",
    "noSignOutAction": "Aucune action de déconnexion n'est disponible dans le contexte d'authentification actuel."
  },
  "errors": {
    "notAuthorized": {
      "title": "Accès refusé",
      "body": "Vous n'avez pas l'autorisation d'accéder à cette section. Contactez l'administrateur si vous pensez qu'il s'agit d'une erreur."
    }
  },
  "common": {
    "actions": {
      "back": "Retour",
      "cancel": "Annuler",
      "close": "Fermer",
      "delete": "Supprimer",
      "edit": "Modifier",
      "installApp": "Installer l'application",
      "loading": "Chargement...",
      "no": "No",
      "logout": "Se déconnecter",
      "openApp": "Ouvrir l'application",
      "processing": "Déconnexion...",
      "retry": "Réessayer",
      "save": "Enregistrer",
      "yes": "Oui"
    },
    "back": "Retour",
    "createOrganization": "Créer une organisation",
    "fallbacks": {
      "noAuth": "Non authentifié",
      "noEmail": "Sans e-mail",
      "noOrg": "Sans organisation"
    },
    "language": {
      "en": "Anglais",
      "es": "Espagnol",
      "fr": "Français"
    },
    "orgNamePlaceholder": "Nom de l'organisation (ex. Ferme A)",
    "refreshContext": "Actualiser le contexte",
    "roles": {
      "noRole": "SANS RÔLE",
      "root": "ROOT"
    },
    "select": "Sélectionner",
    "sending": "Envoi...",
    "show": "Afficher",
    "hide": "Masquer",
    "save": "Enregistrer",
    "cancel": "Annuler",
    "delete": "Supprimer",
    "edit": "Modifier",
    "loading": "Chargement",
    "search": "Rechercher",
    "noResults": "Aucun résultat",
    "separator": "—",
    "zoom": "Zoom",
    "refresh": "Actualiser",
    "ok": "OK",
    "openArrow": "Ouvrir →",
    "debug": "Débogage",
    "pagination": {
      "pageOf": "Page {{page}} sur {{total}}",
      "prev": "Préc.",
      "next": "Suiv."
    },
    "states": {
      "pending": "En attente",
      "visible": "Visible",
      "hidden": "Masquée"
    }
  },
  "dashboard": {
    "welcome": "Bienvenue sur GeoField GPS",
    "sessionAs": "Connecté en tant que {{role}}",
    "email": "E-mail",
    "organizationId": "ID de l’organisation",
    "goToDashboard": "Aller au tableau de bord",
    "deleteAccount": "Supprimer le compte",
    "managePlan": "Gérer le plan",
    "subscribePro": "S’abonner à PRO",
    "helpCenter": "Centre d’aide",
    "help": {
      "quickGuide": {
        "title": "Guide rapide",
        "desc": "Apprenez à utiliser l’application pas à pas."
      },
      "faq": {
        "title": "Questions fréquentes",
        "desc": "Réponses aux questions les plus fréquentes."
      },
      "support": {
        "title": "Support",
        "desc": "Vous avez un problème ou une question ? Contactez-nous."
      },
      "updates": {
        "title": "Nouveautés",
        "desc": "Changements, améliorations et mises à jour récentes."
      }
    },
    "adminPanel": {
      "title": "Panneau d'administration",
      "description": "Gérez les utilisateurs, les rôles et les organisations depuis ici.",
      "sections": {
        "users": "Utilisateurs",
        "roles": "Rôles",
        "organizations": "Organisations"
      },
      "columns": {
        "name": "Nom",
        "email": "Email",
        "role": "Rôle",
        "createdAt": "Date de création",
        "description": "Description"
      }
    },
    "adminTools": {
      "title": "Outils d'administration",
      "protectedPanel": "Sélectionnez un module pour administrer votre application. Ce panneau est réservé aux utilisateurs ayant le rôle owner ou admin."
    },
    "administracion": {
      "title": "Administration"
    },
    "adminReportes": {
      "title": "Rapports"
    },
    "cards": {
      "totalCost": "Costo total",
      "totalGeofences": "Geocercas",
      "totalHours": "Horas totales",
      "totalPersons": "Personas"
    },
    "charts": {
      "costByActivity": "Costo por actividad",
      "costByGeofence": "Costo por geocerca",
      "costByPerson": "Costo por persona",
      "hoursByDay": "Horas por día"
    },
    "errorLoad": "Error al cargar el panel de costos.",
    "filters": {
      "apply": "Aplicar",
      "clear": "Limpiar",
      "dateFromLabel": "Desde",
      "dateToLabel": "Hasta"
    },
    "subtitle": "Visualiza los costos agregados por persona, actividad y geocerca.",
    "title": "panel de costos",
    "currentPlan": "Plan actuel",
    "maxPlanEnterprise": "Votre organisation dispose déjà du plan maximal (Enterprise).",
    "subscribeEnterprise": "S’abonner à Enterprise"
  },
  "dashboardCostos": {
    "title": "Tableau de bord des coûts",
    "subtitle": "Visualisez les KPI et les graphiques de coûts par personne, activité et géozone.",
    "currentOrganization": "Organisation actuelle",
    "actions": {
      "refresh": "Actualiser les données",
      "exportData": "Exporter les données",
      "exportGraphic": "Exporter le graphique"
    },
    "kpis": {
      "totalHours": "Heures totales",
      "totalCost": "Coût total",
      "registrations": "Enregistrements",
      "avgRate": "Taux moyen"
    },
    "errors": {
      "invalidAction": "Action invalide",
      "missingDates": "Vous devez sélectionner une plage de dates",
      "invalidDateRange": "La date \"De\" ne peut pas être ultérieure à la date \"Jusqu'à\"",
      "load": "Erreur lors du chargement du tableau de bord des coûts"
    },
    "loading": "Chargement…",
    "chartDimension": "Dimension",
    "chartMetric": "Métrique",
    "chartTitle": "Graphique de coûts",
    "chartType": "Type de graphique",
    "chartTypeArea": "Zone",
    "chartTypeBar": "Barres",
    "chartTypeLine": "Lignes",
    "chartTypePie": "Secteurs",
    "colActividad": "Actividad",
    "colCategoria": "Catégorie",
    "colCosto": "Coût",
    "colFecha": "Date",
    "colGeocerca": "Géozone",
    "colHoras": "Heures",
    "colMoneda": "Devise",
    "colPersona": "Persona",
    "colRegistros": "Enregistrements",
    "colTarifaPromedio": "Taux moyen",
    "dimensionActividad": "Activité",
    "dimensionFecha": "Date",
    "dimensionGeocerca": "Géozone",
    "dimensionPersona": "Personne",
    "filtersActivity": "Actividad",
    "filtersAll": "Tous",
    "filtersApply": "Appliquer les filtres",
    "filtersClear": "Effacer les filtres",
    "filtersFrom": "De",
    "filtersGeofence": "Geocerca",
    "filtersPerson": "Persona",
    "filtersTitle": "Filtres",
    "filtersTo": "À",
    "kpiCurrencies": "Devises",
    "metricCost": "Coût",
    "metricHours": "Heures",
    "metricRecords": "Enregistrements",
    "metricAvgRate": "Taux moyen",
    "tableEmpty": "Aucune donnée à afficher",
    "tableNoResults": "Aucune donnée pour les filtres actuels",
    "tableTitle": "Détails pour la dimension sélectionnée",
    "chartNoData": "Aucune donnée disponible",
    "loadingAuth": "Chargement de votre session et de votre organisation actuelle…",
    "noOrgAssigned": "Il n'y a pas d'organisation active pour cet utilisateur.",
    "noAccess": "Vous n'avez pas accès à ce module",
    "currentRole": "Rôle actuel",
    "noRole": "aucun rôle",
    "loadingPermissions": "Chargement des permissions…",
    "currenciesSummaryTitle": "Résumé par devise",
    "labelHours": "heures",
    "exportNoData": "Aucune donnée à exporter",
    "exportChartError": "Impossible d'exporter le graphique"
  },
  "forgot": {
    "back": "Volver a iniciar sesión",
    "email": "Correo",
    "emailPh": "tu@correo.com",
    "errorEmail": "Ingresa un correo válido.",
    "errorGeneric": "No se pudo enviar el correo.",
    "noteDesc": "El enlace entrará por /auth/callback y te enviará a /reset-contraseña para crear la nueva contraseña.",
    "noteTitle": "Nota",
    "send": "Enviar enlace",
    "sending": "Enviando…",
    "subtitle": "Te enviaremos un enlace para crear una nueva contraseña. Si no te llega, revisa SPAM.",
    "success": "✅ Si el correo existe, te llegará un enlace para crear una nueva contraseña. Revisa SPAM y ábrelo en el mismo navegador.",
    "tip": "Tip: si el enlace falla, genera uno nuevo y ábrelo en una ventana de incógnito.",
    "title": "Réinitialiser le mot de passe"
  },
  "geocercas": {
    "areaUnitLabel": "Unité de surface",
    "areaLabel": "Surface",
    "buttonClearCanvas": "Effacer la carte",
    "buttonDeleteSelected": "Supprimer la sélection",
    "buttonDrawByCoords": "Dessiner par coordonnées",
    "buttonSave": "Enregistrer la géofence",
    "buttonShowAll": "Mostrar todas",
    "buttonShowOnMap": "Afficher sur la carte",
    "buttonShowSelected": "Mostrar seleccionadas",
    "cardListBody": "Vous pourrez bientôt voir ici la liste des géofences existantes et leurs détails. Pour l’instant, utilisez l’option Nouvelle géofence pour créer et modifier.",
    "cardListTitle": "Liste des géofences",
    "cardNewBody": "Créez une nouvelle géofence sur la carte, mesurez sa surface et assignez-la à votre personnel ou à vos activités.",
    "cardNewCta": "Aller à Nouvelle géofence →",
    "cardNewTitle": "Nouvelle géofence",
    "currentOrgLabel": "Organisation actuelle:",
    "currentUserLabel": "Utilisateur:",
    "cursorHint": "Mueve el mouse sobre el mapa",
    "deleteConfirm": "¿Eliminar las geocercas seleccionadas?",
    "deletedCount": "Eliminadas: {{count}}",
    "draftLabel": "Borrador",
    "errorCoordsInvalid": "Coordenadas inválidas. Usa formato: lat,lng (una por línea).",
    "errorNameRequired": "Escribe un nombre para la geocerca.",
    "errorNoGeojson": "No se encontró el GeoJSON de la geocerca.",
    "errorNoShape": "Dessinez une géofence ou créez-en une par coordonnées avant d’enregistrer.",
    "errorSelectAtLeastOne": "Selecciona al menos una geocerca.",
    "lat": "Lat",
    "lng": "Lng",
    "loadingDataset": "Cargando dataset...",
    "loadingGeofence": "Chargement de la géofence…",
    "modalDraw": "Draw",
    "modalHintRule": "1 point = small square | 2 points = rectangle | 3+ = polygon",
    "modalInstruction": "Format:",
    "modalOnePerLine": "(one per line)",
    "modalTitle": "Draw by coordinates",
    "noGeofences": "Vous n’avez pas encore créé de géofences.",
    "noOrgFallback": "— (aucune organisation sélectionnée)",
    "pageSubtitle": "Administrez les géofences de votre organisation. Vous pouvez créer des zones sur la carte, mesurer leur surface et consulter celles qui existent déjà.",
    "pageTitle": "Géofences",
    "panelTitle": "Géofences",
    "placeholderName": "Nom de la zone",
    "pointsLabel": "Pts",
    "savedOk": "Zone enregistrée avec succès.",
    "subtitleNew": "Dessinez une géofence sur la carte et assignez-la à votre personnel ou à vos activités.",
    "titleNew": "Nouvelle géofence",
    "coordsReady": "Figura creada desde coordenadas.",
    "errorSave": "Impossible d'enregistrer la zone. Réessayez.",
    "deleteError": "No se pudo eliminar. Intenta nuevamente.",
    "errorLoad": "No se pudo cargar la geocerca.",
    "showManyOk": "Mostrando {{count}} geocercas.",
    "planUsageTitle": "Geocercas",
    "planAvailableTitle": "Disponibles",
    "draftYes": "sí",
    "draftNo": "no",
    "create": {
      "defaultName": "Maison",
      "nameLabel": "Nom",
      "coordsLabel": "Coordonnées",
      "coordsHint": "(lat, lng) par ligne",
      "missingGeometry": "Ajoutez des coordonnées (texte \"lat, lng\" par ligne) ou dessinez un polygone sur la carte.",
      "polygonFallback": "Si le champ reste vide, le polygone dessiné sur la carte sera utilisé."
    },
    "errors": {
      "noEditPermission": "Vous n'avez pas l'autorisation de modifier.",
      "selectOrganizationFirst": "Sélectionnez d'abord une organisation."
    },
    "plan": {
      "loading": "Cargando plan...",
      "error": "No se pudieron cargar los límites del plan.",
      "unlimited": "Geocercas sin límite configurado.",
      "usage": "Uso actual: {{used}} / {{max}} geocercas",
      "unlimitedShort": "Ilimitadas",
      "limitReached": "Has alcanzado el límite de geocercas de tu plan actual. Actualiza a PRO para continuar.",
      "limitReachedTitle": "Has alcanzado el límite de geocercas de tu plan.",
      "limitReachedBody": "Para crear más geocercas, actualiza tu organización a PRO.",
      "freeHint": "Plan FREE activo. Cuando alcances el límite, podrás hacer mejora de plan a PRO desde aquí.",
      "activePaidHint": "Tu organización tiene un plan con mayor capacidad habilitada."
    },
    "new": {
      "title": "Nouvelle géofence",
      "subtitle": "Dessinez une géofence sur la carte et assignez-la à votre personnel ou à vos activités.",
      "placeholderName": "Nom de la zone",
      "buttonDrawByCoords": "Dessiner par coordonnées",
      "buttonCircleByRadius": "Cercle par rayon",
      "buttonSave": "Enregistrer la géofence"
    }
  },
  "help": {
    "common": {
      "back": "Volver",
      "badge": "Centro de ayuda",
      "breadcrumb": "Centro de Ayuda",
      "goHome": "Ir a Inicio",
      "quickGuideBadge": "Guía rápida",
      "viewFaq": "Ver FAQ"
    },
    "faq": {
      "breadcrumb": "Centre d’aide / Questions fréquentes",
      "title": "Questions fréquentes",
      "subtitle": "Réponses rapides aux questions les plus courantes.",
      "goHome": "Aller à l’accueil",
      "items": [
        {
          "q": "Comment inviter un tracker ?",
          "a": "Allez dans Inviter un tracker, saisissez l’e-mail et envoyez l’invitation."
        },
        {
          "q": "Comment activer un tracker avec un code d’appairage ?",
          "a": "L’administrateur sélectionne la personne dans Inviter un tracker, génère un code et le copie. Le tracker doit se connecter avec Magic Link, ouvrir /tracker-accept, coller le code et appuyer sur Activer le suivi avec le code. Le code ne remplace pas l’identité : il relie uniquement l’organisation, la personne et le tracker authentifié."
        },
        {
          "q": "Puis-je mesurer des surfaces avec l’application ?",
          "a": "Oui. Lorsque vous créez ou modifiez une géofence, l’application calcule la surface du polygone et peut l’afficher en m², hectares ou acres, selon l’unité sélectionnée."
        },
        {
          "q": "Que se passe-t-il si le lien a expiré ?",
          "a": "Demandez une nouvelle invitation depuis l’organisation."
        }
      ],
      "backToPanel": "Ir al panel",
      "sections": [
        {
          "items": [
            {
              "a": "Necesitas una invitación de un Propietario/Admin de una organización. Si no tienes acceso, solicita que te inviten.",
              "q": "¿Cómo obtengo acceso a la app?"
            },
            {
              "a": "Propietario gestiona la organización y administradores. Administrador gestiona datos operativos (geocercas, personal, actividades, asignaciones). Tracker es un usuario de campo que envía puntos GPS.",
              "q": "¿Cuál es la diferencia entre Propietario, Administrador y Tracker?"
            },
            {
              "a": "Sí. Los Propietarios pueden trabajar con varias organizaciones y cambiar usando el selector de organización.",
              "q": "¿Puedo manejar más de una organización?"
            }
          ],
          "title": "Acceso y roles"
        },
        {
          "items": [
            {
              "a": "El tracker puede estar sin conexión, sin permisos de ubicación, o sin asignación activa. Verifica permisos y asignaciones.",
              "q": "¿Por qué veo “Sin datos recientes” en Tracker?"
            },
            {
              "a": "La frecuencia se define en la asignación. El mínimo permitido es 5 minutos para cuidar batería y datos.",
              "q": "¿Cada cuánto se envía la ubicación?"
            },
            {
              "a": "Sí. El tracker puede almacenar puntos y sincronizar cuando regresa la conectividad (según tu build y permisos).",
              "q": "¿Funciona con señal débil?"
            }
          ],
          "title": "seguimiento"
        },
        {
          "items": [
            {
              "a": "Los costos se calculan a partir de las asignaciones (horas) y la tarifa por hora configurada en cada actividad.",
              "q": "¿Cómo se calculan los costos?"
            },
            {
              "a": "Sí. Los reportes se exportan como CSV, que puedes abrir en Excel o Google Sheets.",
              "q": "¿Puedo exportar a Excel?"
            },
            {
              "a": "Sí. Usa los filtros en Reportes y panel Costos para enfocarte por geocerca(s), persona(s), actividad(es) y fechas.",
              "q": "¿Puedo filtrar por geocerca, persona, actividad y rango de fechas?"
            }
          ],
          "title": "Costos y reportes"
        },
        {
          "items": [
            {
              "a": "Solo los puntos necesarios para seguimiento y validación por geocerca. El acceso está controlado por roles y organización.",
              "q": "¿Qué datos de ubicación se guardan?"
            },
            {
              "a": "No. Los datos están aislados por organización (multi-tenant) y protegidos por reglas de seguridad en base de datos.",
              "q": "¿Un tracker puede ver datos de otras organizaciones?"
            }
          ],
          "title": "Datos y privacidad"
        }
      ],
      "seeQuickGuide": "Ver guía rápida"
    },
    "instructions": {
      "badge": "Guide rapide",
      "bestPractice1Body": "Usa siempre el mismo teléfono para evitar cortes en el seguimiento.",
      "bestPractice1Title": "Usa tu teléfono principal",
      "bestPractice2Body": "Mantén batería suficiente o conecta el cargador durante jornadas largas.",
      "bestPractice2Title": "Cuida la batería",
      "bestPractice3Body": "No cierres sesión ni desactives ubicación mientras estés en ruta.",
      "bestPractice3Title": "Mantén la sesión activa",
      "bestPractice4Body": "Si algo no carga, vuelve a abrir el enlace de invitación más reciente.",
      "bestPractice4Title": "Reabre el enlace si falla",
      "goToSteps": "Aller aux étapes",
      "recommendationBody": "Antes de salir, revisa que veas el estado \"Seguimiento activo\" en tu pantalla.",
      "recommendationTitle": "Recomendación",
      "resultBullets": [
        "Tu invitación fue aceptada correctamente.",
        "Concediste permisos de ubicación en el teléfono.",
        "Ves el estado \"Seguimiento activo\".",
        "Mantienes internet y ubicación habilitadas.",
        "Si no funciona, puedes pedir una nueva invitación o contactar soporte."
      ],
      "resultIntro": "Al finalizar, deberías tener todo listo para compartir ubicación sin problemas:",
      "resultTitle": "Qué debes confirmar",
      "steps": {
        "title": "Étape par étape",
        "subtitle": "Suivez cette séquence simple pour activer le tracker en quelques minutes.",
        "items": [
          {
            "title": "Recevez votre invitation",
            "items": [
              "Vous recevrez un lien par e-mail ou message de votre organisation."
            ]
          },
          {
            "title": "Activez avec un code si votre administrateur vous en a donné un",
            "items": [
              "Connectez-vous avec Magic Link.",
              "Ouvrez /tracker-accept, collez le code et appuyez sur Activer le suivi avec le code."
            ]
          },
          {
            "title": "Ouvrez le lien sur votre téléphone",
            "items": [
              "Ouvrez-le sur le même téléphone que vous utiliserez pour le tracker."
            ]
          }
        ]
      },
      "subtitle": "Activez votre tracker avec des étapes simples et des messages clairs, sans configuration technique.",
      "tipsTitle": "Buenas prácticas",
      "title": "Guide rapide du tracker",
      "toc": {
        "title": "Table des matières",
        "subtitle": "Utilisez ces accès pour avancer plus vite.",
        "items": [
          "Étapes",
          "Bonnes pratiques",
          "Modules opérationnels",
          "Résultat attendu",
          "Recommandation"
        ]
      },
      "viewFaq": "Voir la FAQ",
      "viewResult": "Voir le résultat",
      "moduleCards": {
        "title": "Modules opérationnels",
        "subtitle": "Utilisez ces cartes pour accéder rapidement aux modules de planification et d’analyse de l’efficacité.",
        "items": [
          {
            "badge": "PLANIFICATION",
            "title": "Planification",
            "body": "Organisez les tâches par géofence, personne, activité et période. Consultez l’état, l’avancement, les dates et les coûts planifiés pour coordonner les opérations.",
            "highlights": [
              "Créer et revoir les affectations par période.",
              "Coordonner les activités avant l’exécution du travail.",
              "Utiliser les données réelles de l’organisation active."
            ],
            "cta": "Ouvrir Planification",
            "path": "/planificacion"
          },
          {
            "badge": "BENCHMARKING",
            "title": "Benchmarking",
            "body": "Comparez l’efficacité entre géofences, personnes, activités ou affectations avec heures/m², $/m² et des métriques auxiliaires par ha ou km².",
            "highlights": [
              "Identifier les meilleures et les moins bonnes efficacités.",
              "Consulter les alertes et opportunités d’amélioration.",
              "Exporter les résultats en CSV pour une analyse externe."
            ],
            "cta": "Ouvrir Benchmarking",
            "path": "/benchmarking"
          }
        ]
      }
    },
    "reportsGuide": {
      "badge": "Guide des rapports",
      "breadcrumb": "Centre d’aide / Rapports",
      "title": "Guide des rapports",
      "subtitle": "Consultez les données, filtrez les résultats et exportez l’analyse dont vous avez besoin pour décider plus vite.",
      "goHome": "Aller à l’accueil",
      "goToFilters": "Aller aux filtres",
      "openReports": "Ouvrir les rapports",
      "overviewTitle": "Que pouvez-vous consulter dans les rapports ?",
      "overviewBody": "Cette vue vous permet de comprendre la performance par géofence, personne, activité et période, avec un résumé prêt pour la prise de décision opérationnelle.",
      "summaryTitle": "Résultat attendu",
      "summaryBody": "À la fin, vous aurez la bonne vue de la performance et serez prêt à exporter les données pour les partager.",
      "resultTitle": "À vérifier",
      "summaryBullets": [
        "La plage de dates correspond à la période que vous souhaitez analyser.",
        "Les filtres par géofence, personne et activité correspondent à l’opération étudiée.",
        "Les KPI montrent la tendance et mettent en évidence les zones de risque ou d’amélioration.",
        "Vous pouvez exporter les données au format CSV pour partager l’analyse."
      ],
      "toc": {
        "title": "Table des matières",
        "subtitle": "Utilisez ces raccourcis pour aller plus vite.",
        "items": [
          "Vue d’ensemble",
          "Filtres",
          "Exportation",
          "Interprétation",
          "Bonnes pratiques"
        ]
      },
      "cards": [
        {
          "tag": "KPI",
          "title": "Heures totales",
          "body": "Consultez la charge réelle par période et comparez les opérations entre jours, personnes ou géofences."
        },
        {
          "tag": "COÛT",
          "title": "Coût total",
          "body": "Analysez l’impact économique du travail exécuté et identifiez les activités les plus coûteuses."
        },
        {
          "tag": "AFFECTATION",
          "title": "Tendance par activité",
          "body": "Voyez comment chaque activité évolue dans le temps pour prioriser les bonnes actions."
        }
      ],
      "sections": {
        "title": "Comment utiliser les rapports",
        "items": [
          {
            "title": "Définissez la plage de temps",
            "body": "Choisissez la date de début et la date de fin pour concentrer l’analyse sur la période opératoire correcte avant d’interpréter les résultats.",
            "bullets": [
              "Utilisez des jours, des semaines ou des mois selon la décision à prendre.",
              "Vérifiez que la plage inclut tout le travail opérationnel pertinent."
            ]
          },
          {
            "title": "Appliquez des filtres de contexte",
            "body": "Réduisez la vue par géofence, personne et activité pour isoler les problèmes ou comparer les exécutions réelles.",
            "bullets": [
              "Combinez plusieurs filtres pour examiner un détail précis ou une vue générale.",
              "Effacez les filtres pour revenir à la vue globale."
            ]
          },
          {
            "title": "Interprétez les indicateurs",
            "body": "Recherchez des changements d’heures, de coût et de ratios pour identifier les écarts d’efficacité ou les opportunités d’amélioration.",
            "bullets": [
              "Comparez la même période avec les tendances précédentes.",
              "Examinez les valeurs les plus faibles et les plus élevées avant d’agir."
            ]
          },
          {
            "title": "Exportez pour partager",
            "body": "Si l’analyse doit être envoyée par e-mail, Excel ou présentée à une équipe opérationnelle, exportez la table filtrée.",
            "bullets": [
              "Utilisez le CSV pour ouvrir le fichier dans Excel, Google Sheets ou d’autres outils d’analyse.",
              "Faites une exportation segmentée lorsque la requête est très spécifique."
            ]
          }
        ]
      },
      "exportTitle": "Exportation et analyse",
      "exportPrimaryTitle": "Téléchargez pour un travail externe",
      "exportPrimaryBody": "L’export permet d’ouvrir les résultats dans Excel ou Google Sheets pour les partager avec la supervision, la finance ou la coordination.",
      "exportSecondaryTitle": "Utilisez la vue comme diagnostic",
      "exportSecondaryBody": "Le mélange des filtres et des KPI aide à vérifier si l’exécution est conforme au plan ou si l’opération nécessite une correction.",
      "tips": {
        "title": "Bonnes pratiques",
        "items": [
          {
            "title": "Gardez la plage claire",
            "body": "Une plage trop large peut masquer des changements ponctuels; une plage trop courte peut être trop fine pour décider correctement."
          },
          {
            "title": "Filtrez sur le cas réel",
            "body": "Si vous souhaitez comparer deux équipes ou deux zones, limitez l’analyse à ces segments pour éviter le bruit."
          },
          {
            "title": "Utilisez l’export comme preuve",
            "body": "Quand vous devez présenter des résultats, exportez les données propres et partagez le contexte de la période examinée."
          },
          {
            "title": "Analysez la tendance",
            "body": "Ne vous attachez pas seulement à la valeur du jour; comparez la série pour détecter les changements durables."
          }
        ]
      }
    },
    "support": {
      "breadcrumb": "Centre d’aide / Support",
      "calendlyLabel": "Calendly",
      "title": "Support",
      "subtitle": "Contactez-nous pour l’assistance technique, les questions de facturation ou la formation.",
      "goHome": "Aller à l’accueil",
      "emailLabel": "E-mail du support",
      "whatsappLabel": "WhatsApp",
      "viewFaq": "Voir FAQ",
      "faqLink": "Questions fréquentes",
      "notConfigured": "Le contact du support n’est pas encore configuré.",
      "commonProblems": {
        "title": "Problèmes courants",
        "subtitle": "Si quelque chose ne fonctionne pas, consultez ces solutions rapides avant de contacter le support.",
        "items": [
          {
            "title": "Je ne peux pas accepter l’invitation",
            "desc": "Ouvrez le lien le plus récent que vous avez reçu. S’il a expiré ou affiche une erreur, demandez une nouvelle invitation."
          },
          {
            "title": "Le code d’appairage ne fonctionne pas",
            "desc": "Assurez-vous d’abord de vous connecter avec Magic Link dans le même navigateur ou téléphone. Collez ensuite le code le plus récent dans /tracker-accept. Si un message indique que l’utilisateur est déjà lié à une autre personne, l’administrateur doit générer le code pour la bonne personne ou utiliser un autre e-mail de tracker."
          },
          {
            "title": "Le lien ne fonctionne pas",
            "desc": "Copiez-le entièrement dans le navigateur de votre téléphone ou ouvrez-le directement depuis le message d’origine."
          }
        ]
      }
    },
    "onboarding": {
      "title": "Primeros pasos",
      "subtitle": "Cómo comenzar a usar el tracker por primera vez.",
      "orgCreationLimitReached": "Vous avez déjà créé une organisation. Vous pouvez changer d’organisation ou contacter le support pour en créer une autre.",
      "orgCreateFailed": "Impossible de créer l’organisation.",
      "sections": [
        {
          "title": "Invitación y acceso",
          "items": [
            {
              "q": "¿Cómo empiezo a usar el tracker?",
              "a": "Recibirás un enlace de invitación. Solo debes abrirlo desde tu teléfono y seguir los pasos."
            },
            {
              "q": "¿Necesito instalar algo?",
              "a": "No. Solo abre el enlace y acepta los permisos cuando se te soliciten."
            }
          ]
        }
      ]
    },
    "tracker": {
      "title": "Seguimiento de ubicación",
      "subtitle": "Qué significa que el seguimiento esté activo.",
      "sections": [
        {
          "title": "Estado del seguimiento",
          "items": [
            {
              "q": "¿Qué significa 'Seguimiento activo'?",
              "a": "Significa que tu ubicación se está compartiendo correctamente."
            },
            {
              "q": "¿Debo dejar la app abierta?",
              "a": "No siempre. Mientras tu dispositivo tenga permisos y conexión, el seguimiento peut continuer."
            }
          ]
        }
      ]
    },
    "troubleshooting": {
      "title": "Problemas frecuentes",
      "subtitle": "Soluciones rápidas para los casos más comunes.",
      "sections": [
        {
          "title": "Invitación y permisos",
          "items": [
            {
              "q": "No puedo aceptar la invitación",
              "a": "Asegúrate de abrir el enlace más reciente. Si sigue fallando, solicita una nueva invitación."
            },
            {
              "q": "El enlace indica que está inactivo",
              "a": "Eso puede ocurrir si abriste un enlace anterior. Usa el último enlace recibido."
            },
            {
              "q": "No se inicia el seguimiento",
              "a": "Verifica que aceptaste los permisos de ubicación en tu dispositivo."
            }
          ]
        }
      ]
    },
    "geofences": {
      "title": "Geocercas",
      "subtitle": "Qué son y cómo funcionan dentro del seguimiento.",
      "sections": [
        {
          "title": "Conceptos básicos",
          "items": [
            {
              "q": "Qu’est-ce qu’une géofence ?",
              "a": "C’est une zone définie sur la carte pour enregistrer les entrées, sorties ou présences."
            },
            {
              "q": "Puis-je mesurer des surfaces avec l’application ?",
              "a": "Oui. Lorsque vous créez ou modifiez une géofence, l’application calcule la surface du polygone et peut l’afficher en m², hectares ou acres, selon l’unité sélectionnée."
            },
            {
              "q": "¿Tengo que hacer algo como tracker?",
              "a": "No. El sistema registra automáticamente tu actividad cuando corresponde."
            }
          ]
        }
      ]
    },
    "account": {
      "title": "Cuenta y acceso",
      "subtitle": "Preguntas sobre inicio de sesión y acceso a la organización.",
      "sections": [
        {
          "title": "Acceso",
          "items": [
            {
              "q": "¿Cómo inicio sesión?",
              "a": "Usa tu correo y contraseña desde la pantalla de inicio."
            },
            {
              "q": "¿Qué hago si estoy en la organización incorrecta?",
              "a": "Asegúrate de usar el enlace de invitación correcto o vuelve a ingresar con la cuenta indicada."
            }
          ]
        }
      ]
    },
    "changelog": {
      "breadcrumb": "Centre d’aide / Journal des modifications",
      "back": "Retour",
      "title": "Journal des modifications",
      "subtitle": "Améliorations récentes et mises à jour de l’application.",
      "goHome": "Aller à l’accueil",
      "releases": [
        {
          "version": "v1.2.0 · 2026-04",
          "items": [
            "Amélioration du flux d’invitation des trackers",
            "Suivi plus stable et plus fiable",
            "Interface plus claire et plus cohérente",
            "Correction d’erreurs lors de l’activation du suivi"
          ]
        },
        {
          "version": "v1.1.0 · 2026-03",
          "items": [
            "Système de géofences amélioré",
            "Optimisation des performances",
            "Améliorations de la connexion et de la gestion de session"
          ]
        }
      ],
      "items": [
        {
          "version": "v1.2.0",
          "date": "2026-04",
          "changes": [
            "Mejora en el flujo de invitación de trackers",
            "Seguimiento más estable y confiable",
            "Nueva interfaz más clara y consistente",
            "Corrección de errores en activación de seguimiento"
          ]
        },
        {
          "version": "v1.1.0",
          "date": "2026-03",
          "changes": [
            "Sistema de geocercas mejorado",
            "Optimización de rendimiento",
            "Mejoras en inicio de sesión y manejo de sesión"
          ]
        }
      ]
    }
  },
  "home": {
    "loadingPermissions": "Chargement des permissions...",
    "startBadge": "Accueil",
    "loginToContinue": "Connectez-vous pour continuer.",
    "goToLogin": "Aller à la connexion",
    "quickStart": "Guide rapide",
    "accountStatusBadge": "État du compte",
    "missingContextTitle": "Compte créé avec succès",
    "missingContextBody": "Votre compte existe déjà, mais il n'est pas encore lié à une organisation.",
    "trackerWaitingTitle": "Si vous êtes tracker",
    "trackerWaitingStep1": "Informez l'administrateur que vous avez déjà créé votre compte.",
    "trackerWaitingStep2": "Attendez le lien d'invitation.",
    "trackerWaitingStep3": "Ouvrez le lien depuis ce même téléphone.",
    "trackerWaitingStep4": "Vous pourrez ensuite utiliser le suivi GPS.",
    "installTrackerAppCta": "Installer l'app pour le suivi GPS",
    "pendingInvitation": "Invitation en attente",
    "pending": "En attente",
    "retry": "Vérifier à nouveau",
    "previewEnvironment": "Vous consultez un déploiement Preview.",
    "quickActions": "Actions rapides",
    "manageWorkspace": "Gérer votre espace de travail",
    "manageWorkspaceDesc": "Accédez au panneau principal, consultez votre plan ou gérez votre compte depuis un seul endroit.",
    "subscriptionSummary": "Résumé du plan",
    "helpCenterTitle": "Aide et apprentissage",
    "helpCenterDesc": "Trouvez des guides rapides, des questions fréquentes, du support et les nouveautés du produit.",
    "quickGuideCards": "Centre d'aide",
    "goDashboard": "Aller au tableau de bord",
    "deleteAccount": "Supprimer le compte",
    "help": {
      "title": "Centre d'aide",
      "quick": "Guide rapide",
      "quickDesc": "Apprenez à utiliser l'application pas à pas.",
      "faq": "Questions fréquentes",
      "faqDesc": "Réponses aux questions les plus fréquentes.",
      "support": "Support",
      "supportDesc": "Vous avez un problème ou une question ? Contactez-nous.",
      "news": "Nouveautés",
      "newsDesc": "Changements, améliorations et mises à jour récentes."
    }
  },
  "deleteAccount": {
    "title": "Eliminar cuenta",
    "subtitle": "Solicita la eliminación permanente de tu cuenta de GeoField GPS y de los datos asociados.",
    "warning": {
      "title": "Advertencia",
      "body": "Eliminar tu cuenta es permanente y no se puede deshacer."
    },
    "whatWillBeDeleted": {
      "title": "Qué se eliminará",
      "items": {
        "accountInfo": "Información de la cuenta de usuario",
        "profileData": "Datos del perfil personal",
        "trackerAssignments": "Asignaciones de trackers",
        "gpsRecords": "Registros de ubicación GPS",
        "geofences": "Geocercas creadas por la cuenta",
        "activityLogs": "Registros de actividad relacionados con la cuenta"
      }
    },
    "retention": {
      "title": "Nota de retención",
      "body": "Algunos datos limitados pueden conservarse temporalmente cuando sea necesario por cumplimiento legal, prevención de fraude o motivos de seguridad."
    },
    "processingTime": {
      "title": "Tiempo de procesamiento",
      "body": "Las solicitudes de eliminación de cuenta se procesan dentro de los 30 días posteriores a la recepción de la solicitud. Una vez completado el proceso, la cuenta y los datos asociados no podrán recuperarse."
    },
    "account": {
      "title": "Cuenta",
      "signedInAs": "Sesión iniciada como:",
      "unknownUser": "Usuario desconocido"
    },
    "confirmCheckbox": "Entiendo que esta acción es permanente y que los datos de mi cuenta no podrán recuperarse.",
    "confirmInputLabel": "Escribe DELETE para confirmar",
    "confirmKeyword": "DELETE",
    "submitButton": "Solicitar eliminación de cuenta",
    "submitting": "Enviando...",
    "successMessage": "Tu solicitud de eliminación fue recibida. Tu cuenta y los datos asociados se eliminarán dentro de los próximos 30 días.",
    "publicPolicyLink": "Ver política pública de eliminación",
    "errors": {
      "noAuthenticatedUser": "No se encontró un usuario autenticado activo.",
      "confirmationRequired": "Confirma la acción y escribe \"DELETE\" para continuar.",
      "requestFailed": "No se pudo crear la solicitud de eliminación."
    }
  },
  "inicio": {
    "cards": {
      "common": {
        "soon": "Próximamente"
      },
      "faq": {
        "badge": "Ayuda",
        "body": "Encuentra respuestas a las dudas más comunes sobre invitaciones, roles, costos y uso del tracker.",
        "cta": "Ver preguntas frecuentes",
        "title": "Preguntas frecuentes"
      },
      "instrucciones": {
        "badge": "Guía rápida",
        "body": "Sigue paso a paso cómo configurar organizaciones, geocercas, personal, actividades y trackers.",
        "cta": "Ver instrucciones",
        "title": "Instrucciones"
      },
      "novedades": {
        "badge": "Novedades",
        "body": "Revisa el historial de cambios, nuevas funciones, mejoras y correcciones de la plataforma.",
        "cta": "Ver changelog",
        "title": "Novedades / Changelog"
      },
      "queEs": {
        "badge": "Información",
        "body": "Conoce la visión, los casos de uso y los beneficios de GeoField GPS para tu organización.",
        "cta": "Leer más",
        "title": "¿Qué es GeoField GPS?"
      },
      "soporte": {
        "badge": "Soporte",
        "body": "¿Necesitas ayuda? Contáctanos para soporte técnico, facturación o dudas sobre tu cuenta.",
        "cta": "Ir a soporte",
        "title": "Contacto / Soporte"
      },
      "videoDemo": {
        "badge": "Video",
        "body": "Mira una demostración corta de cómo funciona GeoField GPS en la vida real.",
        "cta": "Ver video demo",
        "title": "Video demo"
      }
    },
    "header": {
      "badge": "Centro de ayuda y recursos",
      "subtitle": "Desde aquí puedes acceder a instrucciones, preguntas frecuentes, soporte y novedades de GeoField GPS.",
      "title": "Bienvenido a tu panel"
    },
    "onboarding": {
      "badge": "Configuration initiale",
      "title": "Commencez en 5 étapes",
      "stepGeocercas": "1. Géofences",
      "stepPersonal": "2. Personnel",
      "stepActividades": "3. Activités",
      "stepAsignaciones": "4. Affectations",
      "stepInvitarTracker": "5. Inviter un tracker"
    },
    "userInfo": {
      "connectedAs": "Conectado como",
      "inOrg": "en la organización",
      "orgIdLabel": "ID de organización:",
      "userLabel": "Usuario:",
      "withRole": "con el rol"
    },
    "billing": {
      "managePlan": "Gérer le plan",
      "managePlanBody": "Vous pouvez accéder à la page Billing pour voir et gérer votre abonnement.",
      "goToBilling": "Aller à Billing",
      "previewNote": ""
    }
  },
  "inviteTracker": {
    "backToTracker": "Volver a Tracker",
    "emailLabel": "Correo electrónico del tracker",
    "emailPlaceholder": "tracker@ejemplo.com",
    "errors": {
      "emailInvalid": "Saisissez une adresse e-mail valide.",
      "emailRequired": "Vous devez saisir une adresse e-mail.",
      "noOrg": "Impossible de résoudre une organisation active pour cet utilisateur.",
      "planBlocked": "Le plan actuel de l’organisation ne permet pas les invitations de tracker.",
      "planLoadFailed": "Impossible de charger les informations du plan pour cette organisation.",
      "trackerCountFailed": "Impossible de vérifier le quota de trackers disponible.",
      "notInOrg": "Votre utilisateur n’est pas lié à l’organisation active.",
      "inviteErrorPrefix": "Erreur lors de l’envoi de l’invitation"
    },
    "form": {
      "buttonSend": "Enviar invitación",
      "buttonSending": "Enviando invitación…",
      "emailHelp": "Se enviará una invitación a este correo.",
      "emailLabel": "Correo electrónico del tracker",
      "emailPlaceholder": "tracker@ejemplo.com",
      "selectHelp": "Si seleccionas un personal, su correo se llenará automáticamente.",
      "selectLabel": "Selecciona personal vigente (opcional)",
      "selectPlaceholder": "-- Seleccionar personal --"
    },
    "diag": {
      "orgUsed": "Organización usada",
      "user": "Usuario",
      "membersLoaded": "Miembros cargados"
    },
    "empty": {
      "noMembers": "No hay personal activo disponible para invitar."
    },
    "ok": {
      "generated": "Invitación generada correctamente.",
      "emailSent": "Correo de invitación enviado correctamente.",
      "fallbackLink": "No se pudo enviar el correo. Usa este enlace para compartir el acceso manualmente.",
      "magicLinkFallback": "Link mágico generado como respaldo."
    },
    "plan": {
      "validating": "Validation du plan de l’organisation…",
      "validationError": "Impossible de valider le plan de l’organisation.",
      "permissionDisabledTitle": "Permission d’invitation non activée",
      "permissionDisabledBody": "Cette organisation ne peut pas inviter de trackers pour le moment.",
      "detectedPlan": "Plan détecté"
    },
    "messages": {
      "createdWithoutEmail": "Se creó el acceso del tracker sin enviar correo electrónico.",
      "genericProcessed": "La invitación para {{correo}} se procesó correctamente.",
      "invited": "Se ha enviado una invitación a {{correo}} para unirse como tracker en {{orgName}}.",
      "linkOnlyNoLink": "La invitación fue creada, pero no se recibió un enlace público.",
      "linkOnlyWithLink": "La invitación fue creada. Usa este enlace para compartir el acceso: {{link}}.",
      "magiclinkSent": "Se envió un link mágico de acceso a {{correo}}.",
      "notOk": "No se pudo completar la invitación. Revisa el correo e inténtalo de nuevo.",
      "serverProblem": "Hubo un problema al contactar al servidor de invitaciones.",
      "unexpectedError": "Error inesperado al procesar la invitación."
    },
    "onlyExistingNote": "Solo se puede invitar a personas existentes en tu organización.",
    "orgFallback": "tu organización",
    "selectPersonLabel": "Selecciona una persona",
    "sendInvite": "Enviar invitación",
    "subtitle": "Selecciona un miembro de tu personal o ingresa un correo manualmente para invitarlo como tracker en {{orgName}}.",
    "title": "Invitar tracker"
  },
  "landing": {
    "accessBody": "Esta aplicación requiere una cuenta invitada por un administrador. Si no tienes acceso, solicita una invitación a tu organización.",
    "accessHint": "Consejo: usa \"Link mágico\" si tu administrador te invitó con correo.",
    "accessTitle": "Acceso con cuenta autorizada",
    "assistanceControlBody": "Verifica quién estuvo dentro de cada geocerca, en qué horario y en qué actividad.",
    "assistanceControlTitle": "Control de asistencia",
    "brandName": "GeoField GPS",
    "brandTagline": "Control de personal por geocercas",
    "bulletCostsBody": "Consultez des tableaux de bord avec les coûts par personne, activité et géofence.",
    "bulletCostsTitle": "Coûts",
    "bulletGeocercasBody": "Créez des géofences pour vos champs, fermes, sites ou points de service et mesurez les surfaces en m², hectares ou acres.",
    "bulletGeocercasTitle": "Géofences",
    "bulletPersonalBody": "Enregistrez votre personnel et affectez-le à des activités et zones spécifiques.",
    "bulletPersonalTitle": "Personnel",
    "ctaLogin": "Ir al panel de control",
    "ctaMagic": "Entrar con link mágico",
    "ctaPricing": "Voir les tarifs",
    "ctaStart": "Créer un compte gratuit",
    "email": "Correo",
    "footerFaq": "Preguntas frecuentes",
    "footerPrivacy": "Privacidad",
    "footerSupport": "Soporte",
    "footerTerms": "Términos",
    "goPanel": "Ir al panel",
    "goToDashboard": "Ir al panel",
    "heroBadge": "Contrôle intelligent sur le terrain",
    "heroSubtitle": "Vérifiez les lieux visités, le temps passé sur place et les activités réalisées, depuis un seul tableau de bord.",
    "heroTitle": "Vérifiez où travaille votre équipe terrain",
    "heroTitleHighlight": "des géofences intelligentes",
    "heroTitlePrefix": "Gérez votre équipe avec",
    "heroTitleSuffix": "partout dans le monde",
    "invalidEmail": "Correo no válido.",
    "livePanelLabel": "Panel en vivo",
    "livePanelTitle": "Operaciones en tiempo real",
    "demoLiveLabel": "Demo en vivo",
    "demoOperationsAreaLabel": "Zone d’opérations",
    "demoLoop10sLabel": "Loop 10s",
    "loginTitle": "Connexion",
    "magicLoginCta": "Se connecter avec un lien magique",
    "noAccount": "Vous n’avez pas de compte ?",
    "createAccount": "Créer un compte",
    "hasPassword": "Vous avez déjà un mot de passe ?",
    "passwordLogin": "Se connecter avec un mot de passe",
    "login": "Iniciar sesión",
    "loginButton": "Entrar",
    "logout": "Se déconnecter",
    "magicEnter": "Iniciar sesión con enlace mágico",
    "magicLinkError": "No se pudo enviar el enlace. Inténtalo de nuevo.",
    "magicLinkSent": "Te enviamos un enlace de acceso. Revisa tu correo.",
    "magicNote": "Importante: el acceso funciona solo con el enlace mágico real.",
    "multiOrgBody": "Administra varias empresas o proyectos desde una sola cuenta, con roles y permisos separados.",
    "multiOrgTitle": "Multi organización",
    "privacyMiniNote": "Privacidad: la ubicación se usa solo para funciones de geocerca y seguimiento según permisos otorgados por el usuario.",
    "quickAccessDesc": "Si lo prefieres, puedes iniciar sesión usando un enlace mágico (sin contraseña).",
    "quickAccessTitle": "Quick access",
    "reviewNote": "Nota: Si estás revisando la app (Google Play), utiliza las credenciales provistas en Play Console (App access).",
    "rightsReserved": "Todos los derechos reservados",
    "sending": "Sending...",
    "sendMagic": "Send magic link",
    "statusOnline": "Sistema en línea",
    "support": "Support",
    "zonesActive": "Zones actives",
    "feature1Title": "Supervision du personnel",
    "feature1Body": "Visualisez qui est en route, qui est arrivé et qui a quitté une zone opérationnelle.",
    "feature2Title": "Contrôle par zones",
    "feature2Body": "Définissez des géofences pour des sites, itinéraires, clients ou zones sensibles, mesurez leur surface et obtenez un contexte visuel immédiat.",
    "feature3Title": "Événements d'entrée et de sortie",
    "feature3Body": "Convertissez les positions GPS en événements faciles à examiner pour l'opération, l'audit et le suivi.",
    "feature4Title": "Prêt pour les équipes terrain",
    "feature4Body": "Utilisez-le dans des opérations commerciales, techniques, logistiques ou de supervision territoriale.",
    "useCase1Title": "Sécurité privée",
    "useCase1Body": "Contrôlez les rondes de gardiens, les entrées dans les zones restreintes et la supervision des équipes.",
    "useCase2Title": "Équipes commerciales",
    "useCase2Body": "Vérifiez les visites clients, la couverture territoriale et l'activité des vendeurs.",
    "useCase3Title": "Opérations techniques",
    "useCase3Body": "Supervisez les techniciens de terrain et validez les entrées et sorties dans les zones de travail.",
    "useCase4Title": "Logistique urbaine",
    "useCase4Body": "Surveillez les mouvements dans les zones opérationnelles et détectez les événements automatiquement."
  },
  "login": {
    "advancedOptions": "Options avancées",
    "back": "Retour",
    "badge": "(connexion-V31 NO-JS)",
    "debug": {
      "lang": "LANG DEBUG",
      "i18n": "I18N DEBUG",
      "supabase": "Supabase"
    },
    "email": "E-mail",
    "emailLabel": "E-mail",
    "emailPlaceholder": "votre.email@exemple.com",
    "errorInvalidCredentials": "Identifiants invalides.",
    "errorMagicLink": "Impossible d'envoyer le lien magique.",
    "errorMagicLinkUnexpected": "Erreur inattendue lors de l'envoi du lien magique.",
    "errorMissingCredentials": "E-mail ou mot de passe manquant.",
    "errorMissingEmail": "Vous devez saisir un e-mail.",
    "errorResetPassword": "Impossible d'envoyer l'e-mail de récupération.",
    "errorResetPasswordUnexpected": "Erreur inattendue lors de l'envoi de l'e-mail de récupération.",
    "errors": {
      "bootstrapFailed": "Bootstrap a échoué (HTTP {{status}}). {{details}}",
      "invalidEmail": "Saisissez une adresse e-mail valide.",
      "unknown": "Une erreur est survenue lors de la connexion."
    },
    "errorUnexpected": "Erreur inattendue lors de la connexion.",
    "forgotPassword": "Mot de passe oublié ?",
    "forgotPasswordAlt": "Vous préférez réinitialiser votre mot de passe ? (envoyer un e-mail)",
    "goToDashboard": "Aller au tableau de bord",
    "goToNext": "Aller à",
    "hidePassword": "Masquer le mot de passe",
    "info": "Connexion WebView/TWA stable : envoi natif (pas d'événements JS), anti rate-limit par conception.",
    "infoMagicLinkSent": "Nous avons envoyé un lien magique à votre e-mail.",
    "infoResetPasswordSent": "Nous vous avons envoyé un e-mail pour réinitialiser votre mot de passe. Vérifiez votre boîte de réception.",
    "hints": {
      "useResetPassword": " — Si vous n'avez jamais créé de mot de passe dans cet environnement, utilisez \"{{resetTitle}}\" pour le créer puis connectez-vous avec le mot de passe."
    },
    "loadingSession": "Chargement de votre session…",
    "magicButton": "Envoyer un lien magique",
    "magicDescription": "Nous enverrons un lien sécurisé à votre e-mail pour vous connecter sans mot de passe.",
    "magicLinkButton": "Envoyer un lien magique",
    "magicLinkDescription": "Nous enverrons un lien sécurisé à votre e-mail pour vous connecter sans mot de passe.",
    "magicLinkSent": "Nous avons envoyé un lien magique à votre e-mail.",
    "magicLinkTitle": "Se connecter avec un lien magique",
    "magicSubmitting": "Envoi du lien…",
    "modeDesc": "Si la connexion réussit, le serveur redirige vers /auth/callback avec des jetons.",
    "modeMagic": "Lien magique",
    "modePassword": "Mot de passe",
    "modeReset": "Réinitialiser",
    "modeTitle": "Mode : NO-JS (envoi natif du formulaire)",
    "nextHint": "Utile pour les tests en PREVIEW. En production, vous ne le changez normalement pas.",
    "nextSuffix": "(next)",
    "password": "Mot de passe",
    "passwordLabel": "Mot de passe",
    "passwordLoginButton": "Se connecter avec mot de passe",
    "passwordPlaceholder": "Saisissez votre mot de passe",
    "passwordTip": "Astuce : en Preview et en Production, le mot de passe est différent (Supabase différent).",
    "previewBadge": "PREVIEW",
    "sessionActive": "Vous avez déjà une session active.",
    "sessionStarted": "✅ Session démarrée. Entrée en cours…",
    "showPassword": "Afficher le mot de passe",
    "submit": "Se connecter",
    "submitting": "Connexion en cours…",
    "subtitle": "Accédez à votre compte GeoField GPS",
    "title": "Se connecter",
    "userNotAuthorized": "Cet e-mail n'est pas autorisé. Demandez une invitation à l'administrateur."
  },
  "orgs": {
    "title": "Organisations",
    "myTitle": "Mes organisations",
    "createNew": "Créer une nouvelle organisation",
    "newTitle": "Nouvelle organisation",
    "form": {
      "name": "Nom",
      "slugOptional": "Slug (facultatif)",
      "namePlaceholder": "Ex. Ferme principale",
      "slugPlaceholder": "ex. ferme-principale",
      "create": "Créer"
    }
  },
  "planning": {
    "header": {
      "badge": "Contrôle opérationnel de gestion",
      "title": "Planification opérationnelle",
      "subtitle": "Planifiez les travaux par géofence, comparez l’exécution réelle au budget opérationnel et détectez les écarts avec des feux, des filtres et une exportation de gestion."
    },
    "badges": {
      "localDemo": "Données démo locales",
      "organizationData": "Données de l’organisation sélectionnée"
    },
    "periods": {
      "week": "Semaine",
      "month": "Mois",
      "quarter": "Trimestre",
      "semester": "Semestre",
      "year": "Année",
      "custom": "Plage personnalisée"
    },
    "periodSelector": {
      "title": "Période d’analyse",
      "from": "De",
      "to": "À"
    },
    "filters": {
      "title": "Filtres de gestion Plan vs Réel",
      "subtitle": "Concentrez l’analyse par écarts, géofence, activité, statut ou période. La vue filtrée alimente les KPI, le tableau, le Gantt et le CSV.",
      "trafficLight": "Feu",
      "geofence": "Géofence",
      "activity": "Activité",
      "status": "Statut",
      "dateFrom": "Date de début",
      "dateTo": "Date de fin",
      "all": "Tous",
      "allFeminine": "Toutes",
      "showing": "Affichage de {{filtered}} sur {{total}} planifications dans la vue actuelle. Les KPI, le tableau, le Gantt et l’export utilisent ce même filtre."
    },
    "actions": {
      "exportCsv": "Exporter CSV exécutif",
      "exportEmptyHint": "L’export est disponible lorsque la vue filtrée contient des planifications.",
      "clearFilters": "Effacer les filtres",
      "cancel": "Annuler",
      "saving": "Enregistrement...",
      "saveEdit": "Enregistrer la modification",
      "savePlanning": "Enregistrer la planification",
      "viewActive": "Voir actives",
      "viewArchived": "Voir archivées",
      "edit": "Modifier",
      "archive": "Archiver",
      "archiving": "Archivage...",
      "restore": "Restaurer",
      "restoring": "Restauration..."
    },
    "kpis": {
      "visible": "Planifications visibles",
      "closed": "Clôturées",
      "inProgress": "En exécution",
      "operationalProgress": "Avancement opérationnel",
      "plannedHours": "Heures planifiées",
      "realHours": "Heures réelles",
      "hoursDifference": "Écart heures",
      "hoursCompliance": "% conformité heures",
      "plannedCost": "Coût planifié",
      "realCost": "Coût réel",
      "costDifference": "Écart coût",
      "currentView": "Vue actuelle"
    },
    "summary": {
      "title": "Résumé exécutif par feu",
      "subtitle": "Lecture rapide du risque opérationnel selon le pire écart entre les heures et le coût.",
      "percentOfTotal": "{{percent}}% de {{total}} planifications"
    },
    "traffic": {
      "green": "Dans la plage",
      "yellow": "Écart modéré",
      "red": "Écart élevé",
      "none": "Sans base"
    },
    "trafficDescriptions": {
      "green": "Écart jusqu’à 10%.",
      "yellow": "Écart supérieur à 10% et jusqu’à 25%.",
      "red": "Écart supérieur à 25%.",
      "none": "Base planifiée insuffisante."
    },
    "form": {
      "newTitle": "Nouvelle planification opérationnelle",
      "editTitle": "Modifier la planification opérationnelle",
      "newSubtitle": "Enregistrez une planification opérationnelle pour la comparer ensuite à l’exécution réelle.",
      "editSubtitle": "Modifiez la planification de l’organisation sélectionnée sans créer de doublons.",
      "selectGeofence": "Sélectionner une géofence",
      "selectActivity": "Sélectionner une activité",
      "startDate": "Date de début",
      "endDate": "Date de fin",
      "plannedHours": "Heures planifiées",
      "plannedCost": "Coût planifié",
      "status": "Statut",
      "notes": "Notes",
      "notesPlaceholder": "Notes opérationnelles",
      "autoCostHint": "Calculé automatiquement selon le tarif de l’activité et les heures{{currency}}.",
      "manualCostHint": "Aucun tarif horaire{{currency}}. Saisissez le coût manuellement.",
      "editSaveHint": "L’enregistrement met à jour cette planification dans l’organisation sélectionnée.",
      "newSaveHint": "L’enregistrement crée la planification dans l’organisation sélectionnée et actualise la liste."
    },
    "status": {
      "draft": "En attente",
      "approved": "En cours",
      "closed": "Terminée",
      "archived": "Archivée"
    },
    "table": {
      "activeTitle": "Planifications actives",
      "archivedTitle": "Planifications archivées",
      "activeSubtitle": "Vue active avec budget, exécution réelle, écarts, feu et totaux.",
      "archivedSubtitle": "Historique opérationnel archivé. Utile pour l’audit et la révision ultérieure.",
      "totalFilteredView": "Total vue filtrée",
      "filteredView": "Vue filtrée",
      "columns": {
        "id": "ID",
        "geofence": "Géofence",
        "activity": "Activité",
        "startDate": "Date début",
        "endDate": "Date fin",
        "plannedHours": "Heures planifiées",
        "plannedCost": "Coût planifié",
        "realHours": "Heures réelles",
        "realCost": "Coût réel",
        "hoursDiff": "Écart heures",
        "costDiff": "Écart coût",
        "trafficLight": "Feu",
        "status": "Statut",
        "actions": "Actions"
      }
    },
    "empty": {
      "noFilterResults": "Aucune planification ne correspond aux filtres sélectionnés.",
      "noArchived": "Aucune planification archivée pour cette organisation.",
      "noActive": "Aucune planification enregistrée pour cette organisation."
    },
    "gantt": {
      "task": "Tâche",
      "titles": {
        "week": "Gantt opérationnel hebdomadaire",
        "month": "Gantt opérationnel mensuel",
        "quarter": "Gantt opérationnel trimestriel",
        "semester": "Gantt opérationnel semestriel",
        "year": "Gantt opérationnel annuel",
        "customDay": "Gantt opérationnel personnalisé par jour",
        "customWeek": "Gantt opérationnel personnalisé par semaine",
        "customMonth": "Gantt opérationnel personnalisé par mois"
      },
      "modes": {
        "active": "planifications actives",
        "archived": "planifications archivées"
      },
      "rangeLabel": " Du {{from}} au {{to}}.",
      "subtitles": {
        "day": "Vue par jours calendaires pour réviser {{mode}}.{{rangeLabel}}",
        "week": "Vue par semaines opérationnelles pour réviser {{mode}}.{{rangeLabel}}",
        "quarter": "Vue trimestrielle groupée par mois pour réviser {{mode}}.{{rangeLabel}}",
        "semester": "Vue semestrielle groupée par mois pour réviser {{mode}}.{{rangeLabel}}",
        "year": "Vue annuelle groupée par mois pour réviser {{mode}}.{{rangeLabel}}",
        "month": "Vue groupée par mois pour réviser {{mode}}.{{rangeLabel}}"
      }
    },
    "calendar": {
      "weekLabel": "Sem {{number}}",
      "weekdaysShort": {
        "sun": "Dim",
        "mon": "Lun",
        "tue": "Mar",
        "wed": "Mer",
        "thu": "Jeu",
        "fri": "Ven",
        "sat": "Sam"
      },
      "monthsShort": {
        "jan": "Jan",
        "feb": "Fév",
        "mar": "Mar",
        "apr": "Avr",
        "may": "Mai",
        "jun": "Juin",
        "jul": "Juil",
        "aug": "Aoû",
        "sep": "Sep",
        "oct": "Oct",
        "nov": "Nov",
        "dec": "Déc"
      }
    },
    "modes": {
      "active": "Actives",
      "archived": "Archivées"
    },
    "csv": {
      "id": "ID",
      "geofence": "Géofence",
      "activity": "Activité",
      "startDate": "Date début",
      "endDate": "Date fin",
      "plannedHours": "Heures planifiées",
      "plannedCost": "Coût planifié",
      "realHours": "Heures réelles",
      "realCost": "Coût réel",
      "hoursDifference": "Différence heures",
      "costDifference": "Différence coût",
      "trafficLight": "Feu",
      "trafficDetail": "Détail du feu",
      "status": "Statut",
      "notes": "Notes",
      "mode": "Mode",
      "exportDate": "Date d’export"
    },
    "validation": {
      "selectGeofence": "Sélectionnez une géofence.",
      "selectActivity": "Sélectionnez une activité.",
      "startDate": "Saisissez une date de début.",
      "endDate": "Saisissez une date de fin.",
      "invalidDates": "Format de dates invalide.",
      "endBeforeStart": "La date de fin ne peut pas être antérieure à la date de début.",
      "plannedHours": "Saisissez les heures planifiées.",
      "plannedHoursPositive": "Les heures doivent être un nombre supérieur ou égal à 0.",
      "plannedCost": "Saisissez le coût planifié.",
      "plannedCostPositive": "Le coût doit être un nombre supérieur ou égal à 0.",
      "invalidStatus": "Statut invalide.",
      "reviewFields": "Vérifiez les champs marqués pour continuer."
    },
    "alerts": {
      "completeRequired": "Complétez les champs requis avant d’enregistrer.",
      "noActiveOrg": "Aucune organisation active pour enregistrer la planification.",
      "saved": "Planification enregistrée correctement.",
      "updated": "Planification mise à jour correctement.",
      "saveError": "Impossible d’enregistrer la planification.",
      "archived": "Planification archivée correctement.",
      "archiveError": "Impossible d’archiver la planification.",
      "restored": "Planification restaurée correctement.",
      "restoreError": "Impossible de restaurer la planification."
    },
    "confirm": {
      "archive": "Archiver la planification {{id}} ? Cette action la masquera de la liste active.",
      "restore": "Restaurer la planification {{id}} ? Elle reviendra comme brouillon dans la liste active."
    },
    "errors": {
      "loadDb": "Impossible de charger la planification depuis Supabase. Affichage de la démo locale."
    },
    "fallbacks": {
      "unnamedGeofence": "Géofence sans nom",
      "unnamedActivity": "Activité sans nom",
      "undefinedGeofence": "Géofence non définie",
      "undefinedActivity": "Activité non définie",
      "geofencePrefix": "Géofence",
      "activityPrefix": "Activité"
    },
    "loading": {
      "fromSupabase": "Chargement de la planification depuis Supabase..."
    },
    "demo": {
      "campusNorth": "Campus Nord",
      "initialSurvey": "Relevé initial",
      "perimeterMarking": "Marquage du périmètre"
    }
  },
  "personal": {
    "bannerCreated": "Personal creado exitosamente.",
    "bannerDeletedOk": "Registro eliminado correctamente.",
    "bannerEditMode": "Modo edición.",
    "bannerLoadingSession": "Cargando sesión…",
    "bannerLoginRequired": "Debes iniciar sesión para acceder a esta sección.",
    "bannerNewMode": "Modo creación de personal.",
    "bannerRefreshedOk": "Datos actualizados correctamente.",
    "bannerSelected": "Registro seleccionado.",
    "bannerUpdated": "Personal actualizado correctamente.",
    "buttonDelete": "Eliminar",
    "buttonEdit": "Modifier",
    "buttonFullList": "Ver todo",
    "buttonNew": "Nouveau",
    "buttonRefresh": "Actualiser",
    "buttonSave": "Guardar",
    "confirmDelete": "Êtes-vous sûr de vouloir supprimer cet enregistrement ? (suppression logique)",
    "errorDelete": "No se pudo eliminar el registro.",
    "errorDeleteNoRows": "No se pudo eliminar: el registro no existe o ya fue eliminado.",
    "errorLoad": "Erreur lors du chargement du personnel.",
    "errorMissingEmail": "El correo es requerido.",
    "errorMissingName": "El nombre es requerido.",
    "errorMissingUser": "No se pudo obtener el usuario autenticado.",
    "errorMustSelectForDelete": "Debes seleccionar un registro para eliminarlo.",
    "errorMustSelectForEdit": "Debes seleccionar un registro para editarlo.",
    "errorNoAuthUser": "No existe un usuario autenticado.",
    "errorNoPermissionCreate": "No tienes permisos para crear personal.",
    "errorNoPermissionDelete": "No tienes permisos para eliminar personal.",
    "errorNoPermissionEdit": "No tienes permisos para editar personal.",
    "errorNoPermissionSave": "No tienes permisos para guardar cambios.",
    "errorPhonePolicy": "El teléfono debe comenzar con + (formato internacional E.164).",
    "errorSave": "No se pudo guardar el personal.",
    "errorSaveNoRecord": "No se recibió registro actualizado.",
    "fieldActive": "Actif",
    "fieldEmail": "E-mail",
    "fieldLastName": "Nom de famille",
    "fieldName": "Prénom",
    "fieldPhonePlaceholder": "Téléphone (+593…)",
    "formTitleEdit": "Editar personal",
    "formTitleNew": "Nouveau membre du personnel",
    "no": "No",
    "onlyActive": "Actifs uniquement",
    "orgFallback": "Sin organización",
    "orgInfoLabel": "Organización:",
    "pillCanEdit": "Editable",
    "pillReadOnly": "Solo lectura",
    "processing": "Traitement en cours...",
    "roleLabel": "Rôle :",
    "searchPlaceholder": "Rechercher par prénom, nom, e-mail ou téléphone…",
    "table": {
      "columns": {
        "active": "Actif",
        "email": "Email",
        "end": "Fin",
        "firstName": "Prénom",
        "lastName": "Apellido",
        "phone": "Téléphone",
        "start": "Inicio"
      },
      "loading": "Cargando…",
      "noActive": "No hay personal activo."
    },
    "tableActive": "Actif",
    "tableEmail": "E-mail",
    "tableLastName": "Nom de famille",
    "tableName": "Prénom",
    "tableNoResults": "No se encontraron resultados.",
    "tablePhone": "Téléphone",
    "title": "Personnel",
    "noActiveSession": "Il n'y a pas de session active",
    "legacyTable": {
      "actions": "Actions",
      "softDelete": "Supprimer (soft)",
      "todoEdit": "TODO : Modifier"
    },
    "yes": "Sí",
    "upgrade": "Mettre à niveau 🚀",
    "upgradeNow": "Mettre à niveau maintenant",
    "active": "Actif",
    "email": "E-mail",
    "firstName": "Prénom",
    "lastName": "Nom de famille",
    "phone": "Téléphone",
    "actions": "Actions",
    "noActive": "Aucun personnel actif.",
    "usedLimit": "{{used}} sur {{limit}} utilisés"
  },
  "reportes": {
    "activityNoName": "Actividad sin nombre",
    "buttonDownloadCsv": "Descargar CSV",
    "colActividad": "Actividad",
    "colCosto": "Costo",
    "colFin": "Fin",
    "colGeocerca": "Geocerca",
    "colHoras": "Horas",
    "colInicio": "Inicio",
    "colMoneda": "Moneda",
    "colPersona": "Persona",
    "colTarifa": "Tarifa/hora",
    "csvHeaderActividad": "Actividad",
    "csvHeaderCosto": "Costo_total",
    "csvHeaderFin": "Fin",
    "csvHeaderGeocerca": "Geocerca",
    "csvHeaderHoras": "Horas",
    "csvHeaderInicio": "Inicio",
    "csvHeaderMoneda": "Moneda",
    "csvHeaderPersona": "Persona",
    "csvHeaderTarifa": "Tarifa_hora",
    "csvHeaderTotal": "Costo_total",
    "errorCsv": "No se pudo generar el archivo CSV.",
    "errorLabel": "Error:",
    "errorLoad": "Error al cargar los reportes.",
    "errorLoadFilters": "Error al cargar filtros (personas, actividades, geocercas).",
    "errorLoadReport": "Error al cargar el reporte de costos.",
    "errorRangeInvalid": "La fecha \"Desde\" no puede ser mayor que la fecha \"Hasta\".",
    "errorViewMissing": "La vista v_costos_detalle aún no está creada en Supabase.",
    "exportNoData": "No hay datos para exportar.",
    "filters": {
      "activityLabel": "Actividad",
      "apply": "Aplicar filtros",
      "clear": "Limpiar filtros",
      "dateFromLabel": "Desde",
      "dateToLabel": "Hasta",
      "geofenceLabel": "Geocerca",
      "personLabel": "Persona"
    },
    "filtersActivity": "Actividad",
    "filtersAll": "Todos",
    "filtersApply": "Aplicar filtros",
    "filtersClear": "Effacer les filtres",
    "filtersFrom": "De",
    "filtersGeofence": "Geocerca",
    "filtersPerson": "Persona",
    "filtersTitle": "Filtres",
    "filtersTo": "À",
    "geofenceNoName": "Geocerca sin nombre",
    "headerSubtitle": "Consulta y exporta los costos por persona, actividad y geocerca.",
    "loadingReport": "Cargando reporte…",
    "noAccessBody": "No tienes permisos para visualizar los reportes de costos. Este módulo está disponible solo para propietarios y administradores.",
    "personNoName": "Persona sin nombre",
    "summaryRecordsHelp": "Cantidad de filas que cumplen con los filtros actuales.",
    "summaryRecordsLabel": "Registros",
    "summaryTotalCostHelp": "Suma de los costos calculados por persona, actividad y geocerca.",
    "summaryTotalCostLabel": "Costo total",
    "summaryTotalHoursHelp": "Suma de las horas de todas las asignaciones en el rango seleccionado.",
    "summaryTotalHoursLabel": "Horas totales",
    "table": {
      "activity": "Actividad",
      "currency": "Moneda",
      "end": "Fin",
      "geofence": "Geocerca",
      "hours": "Horas",
      "noResults": "No se encontraron registros para los filtros seleccionados.",
      "person": "Persona",
      "rate": "Tarifa/hora",
      "start": "Inicio",
      "title": "Detalle de costos",
      "total": "Costo total"
    },
    "tableEmpty": "No hay registros para los filtros seleccionados.",
    "tableExportButton": "Exportar CSV",
    "tableExportHelp": "Exporta el detalle actual como archivo CSV.",
    "tableTitle": "Detalle de costos",
    "title": "Reportes de costos"
  },
  "resetPassword": {
    "backHome": "Ir a la landing",
    "backToLogin": "Volver a iniciar sesión",
    "confirmPassword": "Confirmar contraseña",
    "confirmPlaceholder": "Repite",
    "invalidOrExpired": "El enlace de recuperación es inválido o expiró. Solicita uno nuevo.",
    "loading": "Preparando enlace de recuperación…",
    "newPassword": "Nueva contraseña",
    "newPasswordPlaceholder": "Mínimo 8 caracteres",
    "noSession": "No hay una sesión válida para restablecer la contraseña. Vuelve a solicitar una.",
    "noticeType": "Sesión detectada. Si este enlace no era de recuperación, vuelve a iniciar sesión normalmente.",
    "passwordMin": "La contraseña debe tener al menos 8 caracteres.",
    "passwordMismatch": "Las contraseñas no coinciden.",
    "saveButton": "Je réinitialise mon mot de passe",
    "saving": "Guardando…",
    "subtitle": "Crea una nueva contraseña para tu cuenta.",
    "success": "Contraseña actualizada correctamente. Ahora puedes iniciar sesión.",
    "tip": "Tip: vuelve a /inicio de sesión, escribe tu correo y usa \"¿Olvidaste tu contraseña?\" para generar un nuevo enlace.",
    "title": "Réinitialiser le mot de passe",
    "unexpected": "Ocurrió un error al preparar el restablecimiento de contraseña.",
    "updateFailed": "No se pudo actualizar la contraseña. Intenta nuevamente.",
    "updateUnexpected": "Error inesperado al actualizar la contraseña."
  },
  "tracker": {
    "page": {
      "title": "Tracker GPS"
    },
    "attendance": {
      "title": "Journal de présences",
      "noRecords": "Aucun enregistrement",
      "checkIn": "✅ Entrée",
      "checkOut": "🚪 Sortie",
      "columns": {
        "user": "Utilisateur",
        "geofence": "Géofence",
        "event": "Événement",
        "datetime": "Date et heure"
      }
    },
    "panel": {
      "title": "Panneau du tracker",
      "statusActive": "Actif",
      "statusInactive": "Aucune activité",
      "lastUpdateRecent": "Dernière mise à jour récente"
    },
    "gps": {
      "messageStarting": "Démarrage du suivi...",
      "messagePreparing": "Préparation du suivi...",
      "messageActive": "Suivi actif",
      "titleActive": "Suivi actif",
      "browserTitle": "Ouvrez GeoField GPS pour continuer",
      "browserSubtitle": "Votre session est prête. Ce navigateur ne peut pas démarrer le suivi Android.",
      "browserBadge": "Suivi arrêté",
      "openPreviewApp": "Ouvrir GeoField GPS Preview",
      "browserHelp": "Ouvrez le lien dans l'application GeoField GPS installée depuis Google Play. Le suivi ne peut démarrer que dans l'application Android.",
      "browserHelpPreview": "Ce test nécessite la version Android configurée pour Preview. Ouvrez le lien dans cette version. Ne transférez pas cette session en production.",
      "sessionMissingTitle": "Session de suivi indisponible",
      "sessionMissingHelp": "Les positions ne sont pas envoyées. Ouvrez votre invitation en cours pour récupérer la session. Si elle a été révoquée ou a expiré, demandez-en une nouvelle à votre administrateur.",
      "titleStarting": "Démarrage du suivi",
      "subtitleActive": "Votre position est partagée correctement.",
      "subtitleStarting": "Nous préparons votre session pour commencer le suivi.",
      "badgeActive": "Actif",
      "badgeInitializing": "Initialisation",
      "noteUpdated": "Statut mis à jour correctement.",
      "noteWait": "Cela peut prendre quelques secondes."
    },
    "invite": {
      "title": "Autorisation de localisation",
      "intro": "GeoField GPS collecte et utilise votre localisation précise avec votre consentement pour démarrer une session de suivi autorisée, la partager avec l’organisation qui vous a invité et valider les trajets, les géorepérages et les rapports. Le suivi peut fonctionner en arrière-plan ou lorsque l’app n’est pas visible. Vous pouvez arrêter le suivi à tout moment ou révoquer l’autorisation de localisation dans les paramètres de votre appareil.",
      "introStep": {
        "before": "Lisez et acceptez l’avis de localisation précise et de suivi en arrière-plan avant de continuer.",
        "allow": "GeoField GPS collecte, utilise et partage votre localisation précise pendant la session autorisée.",
        "after": " Le suivi peut fonctionner en arrière-plan ou lorsque l’app n’est pas visible."
      },
      "consentLabel": "Je comprends et j’accepte que GeoField GPS collecte, utilise et partage ma localisation précise avec l’organisation qui m’a invité pendant cette session de suivi autorisée, y compris lorsque l’app est en arrière-plan ou n’est pas visible, afin de valider les trajets, les géorepérages et les rapports opérationnels.",
      "acceptContinue": "Accepter et continuer",
      "processing": "Traitement en cours...",
      "permissionCardTitle": "Autoriser l'utilisation de la localisation",
      "permissionCardBody": {
        "before": "À l'étape suivante, l'autorisation du système pour la localisation précise et le suivi en arrière-plan apparaîtra. Appuyez sur",
        "after": "pour l'autoriser et continuer."
      },
      "permissionAction": "Autoriser l'utilisation de la localisation",
      "requestingPermission": "Demande d'autorisation...",
      "permissionAutoContinue": "Si le navigateur affiche l'autorisation, confirmez simplement et le tracker continuera automatiquement.",
      "blockedTitle": "Nous avons besoin de votre position pour continuer",
      "blockedBody": "La localisation est bloquée ou le navigateur n'a pas pu afficher l'autorisation. Vous devez l'activer manuellement pour continuer.",
      "inAppBrowserHint": {
        "before": "Vous êtes dans Gmail ou WhatsApp. Utilisez"
      },
      "chromePath": "Chrome → Paramètres du site → Localisation → Autoriser",
      "statusLabel": "Statut",
      "errors": {
        "missingToken": "Jeton d'invitation manquant.",
        "consentRequired": "Vous devez accepter le consentement avant de continuer.",
        "blockedSite": "La localisation est bloquée pour ce site. Vous devez l'activer manuellement pour continuer.",
        "locationUnavailable": "Impossible d'obtenir la position. Activez le GPS et réessayez.",
        "locationTimeout": "La localisation a pris trop de temps. Réessayez avec un meilleur signal GPS.",
        "permissionFailed": "Impossible d'obtenir l'autorisation de localisation.",
        "blockedChrome": "La localisation est bloquée pour ce site. Dans Chrome : Paramètres du site → Localisation → Autoriser.",
        "locationUnavailableShort": "Impossible d'obtenir la position."
      }
    },
    "history": {
      "traceLabel": "Trace"
    },
    "controls": {
      "centerOnUser": "Centrar en mi posición",
      "refresh": "Refrescar posiciones",
      "showAll": "Mostrar todos",
      "showInside": "Solo dentro de geocercas"
    },
    "errorLoad": "Error al cargar las posiciones de tracker.",
    "legend": {
      "geofence": "Geocerca",
      "insideFence": "Dentro de geocerca",
      "outsideFence": "Fuera de geocerca"
    },
    "status": {
      "offline": "Sin datos recientes",
      "online": "Tracker en línea"
    },
    "subtitle": "Visualiza en tiempo real la ubicación de los trackers dentro de tus geocercas.",
    "table": {
      "activity": "Actividad",
      "geofence": "Geocerca",
      "noResults": "No hay posiciones registradas.",
      "person": "Persona",
      "status": "Estado",
      "timestamp": "Fecha/hora",
      "title": "Últimas posiciones"
    },
    "title": "Tracker GPS"
  },
  "table": {
    "name": "Nom",
    "status": "Statut",
    "lastPosition": "Dernière position",
    "lastUpdate": "Dernière mise à jour"
  },
  "status": {
    "online": "En ligne",
    "stale": "Données anciennes",
    "offline": "Hors ligne"
  },
  "map": {
    "coordinates": "Coordonnées",
    "lat": "Lat",
    "lng": "Lng",
    "legend": "Légende"
  },
  "trackerDashboard": {
    "title": "Tableau de suivi",
    "timeWindows": {
      "1h": "1 heure",
      "6h": "6 heures",
      "12h": "12 heures",
      "24h": "24 heures"
    },
    "sections": {
      "filters": "Filtres",
      "diagnostics": "Diagnostic",
      "map": "Carte"
    },
    "labels": {
      "window": "Période",
      "tracker": "Tracker",
      "geofences": "Géofences",
      "all": "Tous",
      "activeOrg": "Organisation active",
      "activeOrgDebug": "Organisation (active)",
      "detectedPlan": "Forfait détecté",
      "status": "Statut",
      "total": "Total"
    },
    "actions": {
      "resolveOrgAgain": "Recharger l’organisation",
      "refresh": "Actualiser",
      "loading": "Chargement…",
      "centerGeofence": "Centrer la géofence",
      "refreshSessionOrg": "Actualiser la session de l’organisation"
    },
    "states": {
      "validatingPlan": "Vérification du forfait de l’organisation…",
      "planValidationFailed": "Impossible de vérifier le forfait de l’organisation.",
      "moduleUnavailable": "Ce module n’est pas disponible avec le forfait actuel de l’organisation.",
      "requiresPro": "Le tableau de suivi est indisponible pour cette organisation.",
      "upgradeHint": "Vérifiez le statut du forfait et le quota de trackers.",
      "upgradeOrgPrompt": "Gérez le forfait pour vérifier les permissions.",
      "resolvingActiveOrg": "Recherche de l’organisation active…"
    },
    "messages": {
      "loadAssignmentsError": "Impossible de charger les affectations.",
      "loadGeofencesError": "Impossible de charger les géofences.",
      "loadPositionsError": "Impossible de charger les positions.",
      "noActiveAssignments": "Aucune affectation active. Toutes les géofences actives sont affichées ; celle par défaut est présélectionnée.",
      "noActiveGeofencesForAssignments": "Des affectations existent, mais aucune géofence active ne leur correspond dans l’organisation ({{orgId}}).",
      "fallbackGeofenceShown": "Une géofence active a été affichée par défaut pour éviter un panneau vide.",
      "noActiveGeofencesForOrg": "Aucune géofence active disponible pour cette organisation ({{orgId}}).",
      "noVisibleGeofences": "Aucune géofence active et visible disponible pour cette organisation, ou vous ne disposez pas des droits nécessaires.",
      "orgResolveError": "Impossible de déterminer l’organisation",
      "invalidOrgInSession": "L’organisation active de la session est invalide."
    },
    "badges": {
      "assignments": "affectations",
      "trackers": "trackers",
      "geofences": "géofences",
      "polys": "polygones",
      "circles": "cercles",
      "positions": "positions",
      "source": "source",
      "assignedIds": "identifiants affectés",
      "selected": "sélection",
      "bounds": "limites",
      "viewport": "zone visible",
      "intersects": "intersection"
    },
    "map": {
      "initializing": "Initialisation de la carte…",
      "statusPrefix": "carte",
      "circleLabel": "{{name}} (cercle)"
    },
    "tooltip": {
      "tracker": "Tracker",
      "time": "Heure",
      "lat": "Lat",
      "lng": "Lng",
      "accuracy": "Précision",
      "speed": "Vitesse",
      "source": "Src",
      "status": "Statut",
      "lastSeen": "Dernier signal"
    },
    "multiGeofence": {
      "labelBase": "Géofences",
      "labelNone": "Géofences : aucune",
      "labelAll": "Géofences : toutes ({{count}})",
      "labelSelected": "Géofences : {{count}}",
      "searchPlaceholder": "Rechercher une géofence…",
      "showAll": "Tout afficher",
      "hideAll": "Tout masquer",
      "noResults": "Aucun résultat…",
      "close": "Fermer"
    },
    "heroEyebrow": "SUIVI",
    "heroSubtitle": "Visualisez les positions, les filtres, les géofences et les données opérationnelles en temps réel.",
    "status": {
      "online": "En ligne",
      "stale": "Données anciennes",
      "offline": "Hors ligne"
    }
  },
  "trackerGps": {
    "title": "Tracker GPS",
    "lastSend": "Último envío",
    "waitingCoords": "Esperando coordenadas…",
    "debugCopyPaste": "Debug (copiar/pegar)",
    "stateLabel": "Estado",
    "onlyInvited": "Esta página es solo para trackers invitados.",
    "goHome": "Ir al inicio",
    "status": {
      "initializing": "Iniciando tracker…",
      "processingMagicLink": "Procesando Magic Link del Tracker…",
      "sessionOkPreparing": "Sesión OK. Preparando tracker…",
      "readingSession": "Leyendo sesión del tracker…",
      "noSession": "No hay una sesión activa del tracker.",
      "noGeolocation": "Este dispositivo no soporta geolocalización.",
      "active": "Tracker activo",
      "activating": "Activando tracker en la organización…",
      "noPermission": "Tracker sin permiso / onboarding",
      "gpsError": "Error de GPS"
    },
    "errors": {
      "notConfigured": "El tracker no está configurado en este deployment.",
      "noSupabaseClient": "No se encontró el cliente principal de Supabase.",
      "setSession": "Error en setSession:",
      "hashSession": "Error de sesión por hash:",
      "openFromMagicLinkOnly": "Abre esta página solo desde tu Magic Link de Tracker.",
      "geolocationUnavailable": "Geolocalización no disponible."
    },
    "membership": {
      "missingOrgId": "Falta org_id en la URL. Abre esta página desde el link de invitación: /tracker-gps?org_id=<ORG_ID>.",
      "checking": "Verificando membresía…",
      "noValidTokenUser": "No hay token/usuario válido en /tracker-gps.",
      "okSessionCache": "Membresía OK (cache de sesión).",
      "membershipsSelectError": "Error en select de memberships:",
      "alreadyExists": "La membresía ya existe: role={{role}}",
      "runningAccept": "No existe membresía. Ejecutando accept-tracker-invite",
      "acceptError": "Error de accept-tracker-invite:",
      "membershipsRecheckError": "Error de revalidación de memberships:",
      "acceptReturnedButNotCreated": "accept-tracker-invite devolvió OK pero la membresía no fue creada.",
      "acceptOk": "accept-tracker-invite OK.",
      "onboardingException": "Excepción en onboarding:"
    },
    "disclosure": {
      "title": "Ubicación en segundo plano",
      "body1": "GeoField GPS recopila tu ubicación incluso cuando la app está cerrada o el teléfono bloqueado para registrar posiciones y validar entrada y salida de geocercas durante la jornada laboral.",
      "body2": "Esta información se utiliza únicamente para fines operativos de la organización y no se comparte con terceros ni se usa para publicidad. Puedes detener el seguimiento revocando el permiso de ubicación o cerrando sesión.",
      "continue": "Continuar"
    },
    "debugLabels": {
      "send": "send",
      "accept": "accept",
      "orgId": "org_id",
      "membership": "membership",
      "tokenIss": "token_iss",
      "tokenTtlSec": "token_ttl_sec",
      "lastHttpStatus": "last_http_status",
      "lat": "lat",
      "lng": "lng",
      "acc": "acc"
    },
    "perms": {
      "panelTitle": "Autorisations critiques du traceur",
      "panelDesc": "Pour que GeoField GPS continue de fonctionner après le redémarrage du téléphone ou une période de repos, activez ces autorisations critiques.",
      "locationAlways": "Position toujours autorisée",
      "locationAlwaysAlert": "Activez la position TOUJOURS : Paramètres > Applications > GeoField GPS > Autorisations > Position > Toujours autoriser.",
      "batteryUnrestricted": "Batterie sans restriction",
      "batteryUnrestrictedAlert": "Désactivez les restrictions de batterie : Paramètres > Applications > GeoField GPS > Batterie > Sans restriction ou Ne pas optimiser.",
      "autostart": "Démarrage automatique",
      "autostartAlert": "Activez le démarrage automatique : Paramètres / Phone Master / Power Center > Gestion du démarrage automatique > GeoField GPS > Autoriser.",
      "backgroundData": "Données en arrière-plan",
      "backgroundDataAlert": "Autorisez l’activité et les données en arrière-plan : Paramètres > Applications > GeoField GPS > Données mobiles / Batterie > Autoriser l’arrière-plan."
    }
  },
  "pricing": {
    "accessDenied": "Vous n'avez pas l'autorisation de voir la monétisation de cette organisation.",
    "common": {
      "currentPlan": "Plan actuel",
      "loading": "Chargement...",
      "notAvailable": "—",
      "unlimited": "Illimité"
    },
    "actions": {
      "goToBilling": "Aller à la facturation",
      "contactSales": "Contacter les ventes"
    },
    "page": {
      "title": "Plans et tarifs",
      "previewNotice": {
        "prefix": "Cet écran fonctionne en",
        "previewTag": "APERÇU",
        "middle": "et utilise le flux d'abonnement en mode",
        "testTag": "TEST",
        "suffix": "Cela n'affecte pas la production."
      }
    },
    "summary": {
      "detectedPlan": "Plan détecté",
      "noCommercialData": "Aucune donnée commerciale",
      "status": "Statut",
      "trialUntil": "Essai jusqu'au",
      "planCodes": {
        "free": "FREE",
        "pro": "PRO",
        "enterprise": "ENTERPRISE"
      },
      "planCodeUnknown": "{{code}}",
      "maxGeofences": "Max. géoclôtures",
      "maxTrackers": "Max. trackers"
    },
    "free": {
      "title": "Free",
      "subtitle": "Pour démarrer",
      "price": "$0",
      "description": "Conçu pour valider l'utilisation initiale de la plateforme.",
      "currentPlanMessage": "Vous êtes déjà sur le plan Free.",
      "features": {
        "validateFlow": "Idéal pour démarrer et valider le flux de base",
        "upToTrackers": "Jusqu'à {{count}} tracker",
        "geofenceLimits": "Géoclôtures avec limites par plan",
        "billingAndUpgrade": "Accès à la facturation et chemin d'évolution de plan",
        "backendEnforcement": "Le backend applique toujours une limitation réelle"
      }
    },
    "pro": {
      "title": "Pro",
      "subtitle": "Opérations SaaS actives",
      "price": "Pro",
      "description": "Plan recommandé pour activer le module Tracker et opérer avec un abonnement.",
      "higherPlanMessage": "Votre organisation a déjà un plan supérieur ou différent de Free.",
      "reviewBillingMessage": "Consultez la facturation pour le gérer.",
      "features": {
        "upToTrackers": "Jusqu'à {{count}} trackers par organisation",
        "upToGeofences": "Jusqu'à {{count}} géoclôtures",
        "trackerEnabled": "Module Tracker activé",
        "invitesEnabled": "Invitations de trackers activées",
        "stripeSelfManaged": "Abonnement autogéré"
      }
    },
    "enterprise": {
      "title": "Enterprise",
      "subtitle": "Vente assistée",
      "price": "Sur mesure",
      "description": "Pour les organisations nécessitant des conditions commerciales spéciales.",
      "features": {
        "salesOnboarding": "Accompagnement commercial et onboarding guidé",
        "flexibleLimits": "Limites et conditions ajustables",
        "multiTeamReady": "Prêt pour une opération multi-équipes",
        "specialAgreements": "Montée en charge commerciale et accords spéciaux",
        "directSalesContact": "Contact direct avec les ventes"
      }
    },
    "notes": {
      "title": "Notes pour cette phase",
      "backendAuthority": "Le backend reste la vraie autorité pour l'état du plan. Cette page reflète uniquement le plan et affiche les actions commerciales disponibles.",
      "proCheckout": "La mise à niveau vers Pro utilise un checkout sécurisé. Gérez votre abonnement depuis la facturation.",
      "enterpriseSales": "Enterprise est présenté comme canal commercial, sans activer le checkout automatique."
    },
    "status": {
      "active": "Actif",
      "trialing": "Essai",
      "past_due": "Paiement en retard",
      "canceled": "Annulé",
      "paused": "En pause",
      "incomplete": "Incomplet",
      "other": "Statut : {{status}}"
    }
  },
  "billing": {
    "errors": {
      "loadPlanStatus": "Impossible de charger l’état du plan."
    },
    "cancel": {
      "title": "Paiement annulé",
      "subtitle": "Aucun paiement n'a été effectué.",
      "backToBilling": "Retour à la facturation",
      "goHome": "Aller à l'accueil"
    },
    "title": "Facturation",
    "authRequired": "Connectez-vous pour gérer votre plan.",
    "previewNotice": {
      "prefix": "Monétisation en",
      "middle": "(Flux d'abonnement).",
      "suffix": ""
    },
    "actions": {
      "viewPlans": "Voir les plans"
    },
    "labels": {
      "email": "E-mail",
      "orgId": "ID de l’organisation"
    },
    "planState": {
      "title": "État du plan"
    },
    "states": {
      "loadingPlanStatus": "Chargement de l’état du plan..."
    },
    "cards": {
      "currentPlan": "Plan actuel",
      "status": "Statut",
      "trialUntil": "Essai jusqu’au",
      "currentPeriodUntil": "Période actuelle jusqu’au"
    },
    "subscriptionManagement": {
      "title": "Gestion de l’abonnement",
      "description": "Ouvrez la facturation pour gérer votre abonnement.",
      "cancelRenewal": "Annuler le renouvellement",
      "confirmCancelRenewal": "Cela annulera le renouvellement automatique. Votre forfait restera actif jusqu’à la fin de la période de facturation actuelle. Souhaitez-vous continuer ?",
      "cancelingRenewal": "Annulation du renouvellement...",
      "renewalCanceled": "Renouvellement annulé. Le forfait restera actif jusqu’à la fin de la période de facturation.",
      "cancelRenewalError": "Impossible d’annuler le renouvellement."
    },
    "messages": {
      "cancelAtPeriodEnd": "Votre abonnement sera annulé à la fin de la période actuelle.",
      "activePlanExists": "Un plan actif existe déjà pour cette organisation. Le bouton d’upgrade est masqué."
    },
    "upgrade": {
      "productTitle": "Geofences PRO",
      "orgIdLabel": "ID org",
      "notResolved": "(non résolu)",
      "organizationInputLabel": "ID de l’organisation (org_id)",
      "organizationInputPlaceholder": "Ex. ea4f7ebc-651a-48b9-9ac3-b0bdbee1db9a",
      "organizationInputHelp": "Si l’ID n’est pas détecté automatiquement, collez ici l’UUID de l’organisation.",
      "subscribe": "S’abonner à PRO",
      "processing": "Traitement en cours...",
      "noticeTitle": "Avis",
      "messages": {
        "paddleError": "ERREUR DU FOURNISSEUR DE PAIEMENT:\n{{details}}",
        "checkoutUrlMissing": "URL CHECKOUT MANQUANTE:\n{{details}}",
        "paddleException": "EXCEPTION DU FOURNISSEUR DE PAIEMENT:\n{{details}}"
      },
      "errors": {
        "invalidOrgId": "ID d’organisation invalide. Copiez l’UUID et collez-le ici."
      }
    },
    "compareBeforeUpgrade": {
      "title": "Voulez-vous comparer avant de mettre à niveau ?",
      "description": "Consultez la page des plans pour comparer Free, Pro et Enterprise."
    },
    "status": {
      "trialing": "Essai",
      "active": "Actif",
      "pastDue": "Paiement en retard",
      "canceled": "Annulé",
      "free": "Gratuit"
    }
  },
  "reports": {
    "title": "Reportes",
    "currentOrg": "Org actual",
    "sessionLoading": "Cargando tu sesión…",
    "noActiveSession": "No hay sesión activa. Inicia sesión nuevamente.",
    "noActiveOrg": "No hay organización activa para este usuario.",
    "filters": {
      "title": "Filtros",
      "subtitle": "Selecciona rangos y listas. Luego presiona Generar.",
      "reloadLists": "Recargar listas",
      "reloadFilters": "Recargar filtros",
      "clearSelections": "Limpiar selecciones",
      "clearSelectionsTitle": "Limpiar selecciones (no borra fechas)",
      "from": "Desde",
      "to": "Hasta",
      "generate": "Generar",
      "generating": "Generando…",
      "exportCsv": "Exportar CSV",
      "tipLabel": "Tip:",
      "tipMultiSelect": "En listas multi-select usa Ctrl (Windows) / Command (Mac) para seleccionar múltiples.",
      "geofences": "Geocercas",
      "people": "Personas",
      "activities": "Actividades",
      "assignments": "Asignaciones",
      "multi": "(multi)",
      "assignmentFallback": "asignación",
      "assignmentNote": "Nota: si tus asignaciones no tienen personal_id, el cruce con marcajes puede salir vacío."
    },
    "results": {
      "title": "Resultados",
      "generating": "Generando reporte…",
      "rows": "Filas: {{count}}",
      "emptyHint": "Aún no hay datos. Ajusta filtros y genera.",
      "loading": "Cargando…",
      "noDataSelectedFilters": "No hay datos con los filtros seleccionados."
    },
    "table": {
      "day": "Día",
      "person": "Persona",
      "email": "Correo",
      "geofence": "Geocerca",
      "activity": "Actividad",
      "assignment": "Asignación",
      "entry": "Entrada",
      "exit": "Salida",
      "marks": "Marcajes",
      "inside": "Dentro",
      "distanceM": "Dist (m)",
      "rate": "Tarifa",
      "dash": "—"
    },
    "errors": {
      "loadFilters": "Error cargando filtros.",
      "noActiveOrgOrSession": "No hay organización activa o la sesión no está lista.",
      "invalidDateRange": "La fecha \"Desde\" no puede ser mayor que la fecha \"Hasta\".",
      "generateReport": "Error generando reporte.",
      "exportNoData": "No hay datos para exportar."
    }
  },
  "activityAssignments": {
    "title": "Asignación de actividades",
    "subtitle": "Define qué actividad realiza cada persona en un rango de fechas. La misma persona no puede tener dos actividades al mismo tiempo.",
    "session": "Sesión",
    "actions": {
      "new": "+ Nueva asignación",
      "refresh": "Refrescar",
      "edit": "Editar",
      "delete": "Eliminar",
      "clear": "Limpiar",
      "newShort": "Nueva",
      "saveChanges": "Guardar cambios",
      "createAssignment": "Crear asignación",
      "saving": "Guardando..."
    },
    "filters": {
      "trackerPerson": "Tracker / Persona",
      "activity": "Actividad",
      "startFrom": "Inicio desde",
      "endUntil": "Fin hasta",
      "allTrackers": "Todos",
      "allActivities": "Todas"
    },
    "table": {
      "title": "Listado de asignaciones",
      "loading": "Cargando...",
      "person": "Persona",
      "activity": "Actividad",
      "start": "Inicio",
      "end": "Fin",
      "actions": "Acciones",
      "empty": "No hay asignaciones para los filtros actuales."
    },
    "form": {
      "titleCreate": "Nueva asignación",
      "titleEdit": "Editar asignación",
      "titleView": "Detalles / nueva asignación",
      "trackerPerson": "Persona / Tracker",
      "activity": "Actividad",
      "startDate": "Fecha inicio",
      "endDateOptional": "Fecha fin (opcional)",
      "selectOption": "Seleccione..."
    },
    "messages": {
      "initialLoadError": "Error al cargar datos iniciales",
      "activitiesLoadError": "No se pudieron cargar las actividades",
      "trackersLoadError": "No se pudieron cargar los trackers",
      "assignmentsLoadError": "No se pudieron cargar las asignaciones",
      "requiredFields": "Tracker, actividad y fecha de inicio son obligatorios",
      "assignedSuccessfully": "Actividad asignada correctamente",
      "updatedSuccessfully": "Asignación actualizada correctamente",
      "invalidFormMode": "Modo de formulario inválido",
      "constraintOverlap": "No se puede asignar esta actividad: la persona ya tiene otra actividad en ese rango de fechas.",
      "saveError": "Error al guardar la asignación de actividad",
      "deletedSuccessfully": "Asignación eliminada correctamente",
      "deleteError": "No se pudo eliminar la asignación de actividad"
    },
    "overlap": {
      "selectedPerson": "seleccionada",
      "otherActivity": "otra actividad",
      "noEndDate": "sin fecha de fin",
      "message": "La persona {{person}} ya tiene asignada la actividad \"{{activity}}\" entre {{start}} y {{end}}."
    },
    "confirmDelete": "¿Seguro que deseas eliminar la asignación de \"{{activity}}\" para \"{{tracker}}\"?",
    "fallbacks": {
      "activity": "actividad",
      "tracker": "tracker"
    }
  },
  "admin": {
    "dashboard": {
      "title": "Panel de Administración",
      "configRequired": "Configuración requerida",
      "modules": {
        "geocercas": "Geocercas",
        "geocercasV2": "Geocercas V2",
        "personal": "Personal",
        "reports": "Reportes"
      },
      "modulesDescriptions": {
        "geocercas": "Gestiona las geocercas de tu organización",
        "geocercasV2": "Geocercas mejoradas con nueva interfaz",
        "personal": "Gestiona el personal de campo",
        "reports": "Consulta reportes y eventos"
      },
      "logout": "Cerrar sesión"
    },
    "geocercasV2": {
      "title": "Geocercas",
      "showAll": "Mostrar todas",
      "back": "← Volver",
      "savedGeofencesHeader": "Geocercas guardadas",
      "loading": "Cargando...",
      "noGeofences": "No hay geocercas",
      "status": {
        "active": "Activa",
        "inactive": "Inactiva"
      },
      "actions": {
        "view": "Ver",
        "deactivate": "Desactivar",
        "activate": "Activar",
        "edit": "Editar",
        "editInMap": "Editar en mapa",
        "delete": "Eliminar"
      },
      "floatingActions": {
        "save": "Guardar",
        "cancel": "Cancelar"
      },
      "prompt": {
        "name": "Nombre de la geocerca:",
        "newName": "Nuevo nombre (deja igual si no quieres cambiar):",
        "editCoords": "Edita coordenadas (lat,lng por línea). Deja en blanco para mantener:"
      },
      "manualForm": {
        "title": "Crear geocerca manualmente",
        "hintFormat": "Formato: lat,lng por línea. Mínimo 3 líneas.",
        "saveButton": "Guardar manual"
      },
      "labels": {
        "personal": "Personal:",
        "assignments": "Asignaciones:"
      },
      "mapControls": {
        "latLngTip": "Mover cursor para ver Lat/Lng"
      }
    },
    "usersRoles": {
      "title": "Usuarios y Roles",
      "processing": "Procesando…",
      "inviteSection": "Invitar usuario",
      "emailPlaceholder": "correo@dominio.com",
      "fullNamePlaceholder": "Nombre completo",
      "fullNameLabel": "Nombre completo",
      "roleOwner": "OWNER",
      "inviteButton": "Invitar",
      "pendingInvitesTitle": "Invitaciones pendientes",
      "noPending": "No hay invitaciones.",
      "usersTitle": "Usuarios",
      "noUsers": "No hay usuarios registrados.",
      "table": {
        "email": "Correo",
        "name": "Nombre",
        "role": "Rol",
        "date": "Fecha",
        "actions": "Acciones",
        "newRole": "Nuevo Rol"
      },
      "magicLink": "Magic Link",
      "deleteButton": "Eliminar",
      "assignButton": "Asignar",
      "confirmDelete": "¿Eliminar/suspender a {{correo}}?",
      "inviteSuccess": "Invitación enviada a {{correo}}",
      "assignSuccess": "Rol \"{{role}}\" asignado a {{correo}}",
      "magicLinkSentInvite": "Invitación enviada a {{correo}}",
      "magicLinkSentLink": "Enlace mágico enviado a {{correo}}",
      "deleteSuccess": "Usuario {{correo}} eliminado/suspendido"
    },
    "geofences": {
      "errors": {
        "loadFailed": "No se pudo cargar la lista",
        "invalidPolygon": "Dibuja un polígono válido.",
        "saveFailed": "Error al guardar",
        "invalidInput": "Revisa nombre y al menos 3 coordenadas válidas.",
        "createFailed": "No se pudo guardar la geocerca",
        "statusChangeFailed": "No se pudo cambiar estado",
        "deleteFailed": "No se pudo eliminar",
        "noCoordinates": "Geocerca sin coordenadas válidas",
        "minimumPoints": "Se requieren al menos 3 puntos válidos.",
        "editFailed": "No se pudo editar",
        "invalidCoordinates": "Coordenadas inválidas.",
        "invalidPolygonData": "Polígono inválido."
      },
      "messages": {
        "created": "✅ Geocerca guardada.",
        "createdManual": "Geocerca creada (manual).",
        "activated": "✅ Activada",
        "deactivated": "✅ Desactivada",
        "deleted": "🗑️ Eliminada.",
        "updated": "✏️ Geocerca actualizada.",
        "mapEditActive": "🟠 Edición en mapa activa. Ajusta vértices y pulsa 'Guardar cambios'.",
        "editCancelled": "Edición cancelada.",
        "changesSaved": "✅ Cambios guardados."
      },
      "confirmDelete": "¿Eliminar \"{{name}}\"?"
    }
  },
  "trackerPanel": {
    "title": "Panel del Tracker",
    "description": "Aquí verás tus geocercas asignadas, tu estado (dentro/fuera) y podrás reportar incidencias.",
    "logout": "Cerrar sesión"
  },
  "mapaTracking": {
    "traceLabel": "Rastro:",
    "timeWindows": {
      "15min": "15 min",
      "30min": "30 min",
      "60min": "60 min"
    },
    "refresh": "Refrescar",
    "loading": "Cargando…"
  },
  "newOrg": {
    "title": "Nueva organización",
    "labels": {
      "name": "Nombre",
      "slug": "Slug (opcional)"
    },
    "placeholders": {
      "name": "Ej. Finca Principal",
      "slug": "ej. mi-finca-principal"
    },
    "buttons": {
      "create": "Crear",
      "cancel": "Cancelar"
    }
  },
  "geofenceForm": {
    "title": "Nouvelle géofence",
    "fields": {
      "name": "Nombre",
      "coordinates": "Coordenadas",
      "onePerLine": "por línea"
    },
    "placeholders": {
      "name": "Ej. Campo 1",
      "example": "-0.1807, -78.4678"
    },
    "labels": {
      "name": "Nombre",
      "coordinates": "Coordenadas (lat,lng por línea)"
    },
    "actions": {
      "save": "Enregistrer la géofence",
      "saving": "Guardando..."
    },
    "hints": {
      "mapSelection": "Dibuja o selecciona en el mapa; si la caja está vacía, ese polígono será usado."
    },
    "map": {
      "lat": "Lat",
      "lng": "Lng",
      "movePointer": "Mueve el puntero sobre el mapa…"
    },
    "errors": {
      "minPoints": "Se requieren al menos 3 puntos."
    },
    "fallbacks": {
      "unnamed": "Sin nombre"
    },
    "messages": {
      "saved": "Geocerca guardada correctamente.",
      "errorPrefix": "Error",
      "created": "Geocerca creada correctamente.",
      "createError": "Error al crear geocerca",
      "updated": "Geocerca(s) actualizada(s) correctamente.",
      "updateError": "Error al actualizar geocerca",
      "deleted": "Geocerca(s) eliminada(s) correctamente.",
      "deleteError": "Error al eliminar geocerca"
    }
  },
  "geofences": {
    "labels": {
      "personal": "Personal:",
      "assignments": "Asignaciones:"
    },
    "actions": {
      "links": "Vínculos"
    }
  },
  "benchmarking": {
    "header": {
      "badge": "Amélioration continue",
      "title": "Benchmarking",
      "subtitle": "Comparez l’efficacité opérationnelle entre affectations, géofences, personnes ou activités avec heures/m² et $/m²."
    },
    "actions": {
      "refresh": "Actualiser",
      "exportCsv": "Exporter CSV",
      "resetFilters": "Effacer les filtres"
    },
    "alerts": {
      "plannedOnlyTitle": "Données planifiées.",
      "plannedOnlyBody": "La vue actuelle ne contient pas d’heures de tracking liées aux affectations. Benchmarking utilise les heures planifiées et indique la source PLANIFIÉE."
    },
    "filters": {
      "all": "Tous",
      "geofence": "Géofence",
      "person": "Personne / travailleur",
      "activity": "Activité",
      "dateFrom": "Depuis",
      "dateTo": "Jusqu’à",
      "period": "Période groupée",
      "compareBy": "Comparer par",
      "indicator": "Indicateur",
      "chartType": "Type de graphique",
      "title": "Filtres",
      "subtitle": "Ajustez la vue pour comparer l'efficacité opérationnelle."
    },
    "periods": {
      "day": "Jour",
      "week": "Semaine",
      "month": "Mois",
      "quarter": "Trimestre",
      "semester": "Semestre",
      "year": "Année"
    },
    "compareBy": {
      "assignment": "Affectations",
      "geofence": "Géofences",
      "person": "Personnes",
      "activity": "Activités"
    },
    "indicators": {
      "horas_m2": "Heures/m²",
      "costo_m2": "$/m²"
    },
    "chartTypes": {
      "bars": "Barres",
      "lines": "Lignes"
    },
    "kpis": {
      "best": "Meilleure efficacité",
      "worst": "Pire efficacité",
      "average": "Moyenne générale",
      "totalDifference": "Différence cumulée totale",
      "totalDifferenceHint": "Somme des différences vs moyenne",
      "optimizableCost": "Coût potentiellement optimisable",
      "optimizableCostHint": "Excès vs moyenne",
      "optimizableHours": "Heures potentiellement optimisables",
      "optimizableHoursHint": "Excès vs moyenne"
    },
    "chart": {
      "title": "Visualisation",
      "subtitle": "Les barres comparent les groupes; les lignes montrent l’évolution moyenne dans le temps."
    },
    "table": {
      "title": "Tableau comparatif",
      "subtitle": "Les alertes montrent l’écart par rapport à la moyenne visible; elles ne prennent pas de décisions automatiques.",
      "rows": "{{count}} lignes",
      "signal": "Feu",
      "geofence": "Géofence",
      "person": "Personne",
      "activity": "Activité",
      "period": "Période",
      "areaM2": "Surface m²",
      "areaReadable": "Surface lisible",
      "observedHours": "Heures observées",
      "plannedHours": "Heures planifiées",
      "costBase": "Coût de base",
      "costFinal": "Coût final audité",
      "hoursM2": "Heures/m²",
      "costM2": "$/m²",
      "diffAverage": "Écart vs moyenne",
      "cumulativeDiff": "Différence cumulée",
      "evidence": "Source",
      "opportunity": "Opportunité d’amélioration"
    },
    "traffic": {
      "green": "Vert",
      "yellow": "Jaune",
      "red": "Rouge",
      "gray": "Sans données"
    },
    "opportunities": {
      "green": "Maintenir le standard et utiliser comme référence",
      "yellow": "Examiner l’écart modéré",
      "red": "Prioriser l’analyse opérationnelle",
      "gray": "Compléter les données avant comparaison"
    },
    "evidence": {
      "TRACKING": "Tracking",
      "PLANIFICADA": "Planifiée",
      "MIXTA": "Mixte"
    },
    "fallbacks": {
      "geofence": "Géofence sans nom",
      "person": "Personne sans nom",
      "activity": "Activité sans nom"
    },
    "labels": {
      "multiple": "Plusieurs"
    },
    "empty": {
      "chart": "Pas assez de données pour générer le graphique.",
      "table": "Aucune donnée de benchmarking avec les filtres actuels."
    },
    "errors": {
      "load": "Impossible de charger le benchmarking."
    },
    "loading": "Chargement du benchmarking...",
    "csv": {
      "title": "Benchmarking opérationnel",
      "exportedAt": "Date d’exportation"
    }
  },
  "plans100": {
    "catalogLimits": "Jusqu’à {{trackers}} trackers et {{geofences}} géofences",
    "subscribe": "Souscrire à ENTERPRISE 100",
    "upgrade": "Passer à ENTERPRISE 100",
    "maximum": "Votre organisation dispose déjà du forfait maximal (ENTERPRISE 100).",
    "description": "Pour les opérations avec jusqu’à 100 trackers.",
    "limits": "Jusqu’à 100 trackers et 250 géofences",
    "confirmTitle": "Confirmer le passage à {{plan}}",
    "confirmBody": "Votre abonnement actuel passera à {{plan}}. Le fournisseur appliquera le prorata avec votre moyen de paiement existant. Aucun second abonnement ne sera créé.",
    "alreadyActive": "Votre organisation dispose déjà de ce forfait ou d’un forfait supérieur."
  }
}
